webpackJsonp([1],Array(72).concat([
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footer-left.6c20055.png";

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");+function (a) {
  "use strict";
  var b = a.fn.jquery.split(" ")[0].split(".");if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1 || b[0] > 3) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4");
}(jQuery), +function (a) {
  "use strict";
  function b() {
    var a = document.createElement("bootstrap"),
        b = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" };for (var c in b) {
      if (void 0 !== a.style[c]) return { end: b[c] };
    }return !1;
  }a.fn.emulateTransitionEnd = function (b) {
    var c = !1,
        d = this;a(this).one("bsTransitionEnd", function () {
      c = !0;
    });var e = function e() {
      c || a(d).trigger(a.support.transition.end);
    };return setTimeout(e, b), this;
  }, a(function () {
    a.support.transition = b(), a.support.transition && (a.event.special.bsTransitionEnd = { bindType: a.support.transition.end, delegateType: a.support.transition.end, handle: function handle(b) {
        if (a(b.target).is(this)) return b.handleObj.handler.apply(this, arguments);
      } });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var c = a(this),
          e = c.data("bs.alert");e || c.data("bs.alert", e = new d(this)), "string" == typeof b && e[b].call(c);
    });
  }var c = '[data-dismiss="alert"]',
      d = function d(b) {
    a(b).on("click", c, this.close);
  };d.VERSION = "3.3.7", d.TRANSITION_DURATION = 150, d.prototype.close = function (b) {
    function c() {
      g.detach().trigger("closed.bs.alert").remove();
    }var e = a(this),
        f = e.attr("data-target");f || (f = e.attr("href"), f = f && f.replace(/.*(?=#[^\s]*$)/, ""));var g = a("#" === f ? [] : f);b && b.preventDefault(), g.length || (g = e.closest(".alert")), g.trigger(b = a.Event("close.bs.alert")), b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c());
  };var e = a.fn.alert;a.fn.alert = b, a.fn.alert.Constructor = d, a.fn.alert.noConflict = function () {
    return a.fn.alert = e, this;
  }, a(document).on("click.bs.alert.data-api", c, d.prototype.close);
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.button"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;e || d.data("bs.button", e = new c(this, f)), "toggle" == b ? e.toggle() : b && e.setState(b);
    });
  }var c = function c(b, d) {
    this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, d), this.isLoading = !1;
  };c.VERSION = "3.3.7", c.DEFAULTS = { loadingText: "loading..." }, c.prototype.setState = function (b) {
    var c = "disabled",
        d = this.$element,
        e = d.is("input") ? "val" : "html",
        f = d.data();b += "Text", null == f.resetText && d.data("resetText", d[e]()), setTimeout(a.proxy(function () {
      d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? (this.isLoading = !0, d.addClass(c).attr(c, c).prop(c, !0)) : this.isLoading && (this.isLoading = !1, d.removeClass(c).removeAttr(c).prop(c, !1));
    }, this), 0);
  }, c.prototype.toggle = function () {
    var a = !0,
        b = this.$element.closest('[data-toggle="buttons"]');if (b.length) {
      var c = this.$element.find("input");"radio" == c.prop("type") ? (c.prop("checked") && (a = !1), b.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == c.prop("type") && (c.prop("checked") !== this.$element.hasClass("active") && (a = !1), this.$element.toggleClass("active")), c.prop("checked", this.$element.hasClass("active")), a && c.trigger("change");
    } else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active");
  };var d = a.fn.button;a.fn.button = b, a.fn.button.Constructor = c, a.fn.button.noConflict = function () {
    return a.fn.button = d, this;
  }, a(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function (c) {
    var d = a(c.target).closest(".btn");b.call(d, "toggle"), a(c.target).is('input[type="radio"], input[type="checkbox"]') || (c.preventDefault(), d.is("input,button") ? d.trigger("focus") : d.find("input:visible,button:visible").first().trigger("focus"));
  }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function (b) {
    a(b.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(b.type));
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.carousel"),
          f = a.extend({}, c.DEFAULTS, d.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b),
          g = "string" == typeof b ? b : f.slide;e || d.data("bs.carousel", e = new c(this, f)), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle();
    });
  }var c = function c(b, _c) {
    this.$element = a(b), this.$indicators = this.$element.find(".carousel-indicators"), this.options = _c, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 600, c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }, c.prototype.keydown = function (a) {
    if (!/input|textarea/i.test(a.target.tagName)) {
      switch (a.which) {case 37:
          this.prev();break;case 39:
          this.next();break;default:
          return;}a.preventDefault();
    }
  }, c.prototype.cycle = function (b) {
    return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this;
  }, c.prototype.getItemIndex = function (a) {
    return this.$items = a.parent().children(".item"), this.$items.index(a || this.$active);
  }, c.prototype.getItemForDirection = function (a, b) {
    var c = this.getItemIndex(b),
        d = "prev" == a && 0 === c || "next" == a && c == this.$items.length - 1;if (d && !this.options.wrap) return b;var e = "prev" == a ? -1 : 1,
        f = (c + e) % this.$items.length;return this.$items.eq(f);
  }, c.prototype.to = function (a) {
    var b = this,
        c = this.getItemIndex(this.$active = this.$element.find(".item.active"));if (!(a > this.$items.length - 1 || a < 0)) return this.sliding ? this.$element.one("slid.bs.carousel", function () {
      b.to(a);
    }) : c == a ? this.pause().cycle() : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
  }, c.prototype.pause = function (b) {
    return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this;
  }, c.prototype.next = function () {
    if (!this.sliding) return this.slide("next");
  }, c.prototype.prev = function () {
    if (!this.sliding) return this.slide("prev");
  }, c.prototype.slide = function (b, d) {
    var e = this.$element.find(".item.active"),
        f = d || this.getItemForDirection(b, e),
        g = this.interval,
        h = "next" == b ? "left" : "right",
        i = this;if (f.hasClass("active")) return this.sliding = !1;var j = f[0],
        k = a.Event("slide.bs.carousel", { relatedTarget: j, direction: h });if (this.$element.trigger(k), !k.isDefaultPrevented()) {
      if (this.sliding = !0, g && this.pause(), this.$indicators.length) {
        this.$indicators.find(".active").removeClass("active");var l = a(this.$indicators.children()[this.getItemIndex(f)]);l && l.addClass("active");
      }var m = a.Event("slid.bs.carousel", { relatedTarget: j, direction: h });return a.support.transition && this.$element.hasClass("slide") ? (f.addClass(b), f[0].offsetWidth, e.addClass(h), f.addClass(h), e.one("bsTransitionEnd", function () {
        f.removeClass([b, h].join(" ")).addClass("active"), e.removeClass(["active", h].join(" ")), i.sliding = !1, setTimeout(function () {
          i.$element.trigger(m);
        }, 0);
      }).emulateTransitionEnd(c.TRANSITION_DURATION)) : (e.removeClass("active"), f.addClass("active"), this.sliding = !1, this.$element.trigger(m)), g && this.cycle(), this;
    }
  };var d = a.fn.carousel;a.fn.carousel = b, a.fn.carousel.Constructor = c, a.fn.carousel.noConflict = function () {
    return a.fn.carousel = d, this;
  };var e = function e(c) {
    var d,
        e = a(this),
        f = a(e.attr("data-target") || (d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""));if (f.hasClass("carousel")) {
      var g = a.extend({}, f.data(), e.data()),
          h = e.attr("data-slide-to");h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault();
    }
  };a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), a(window).on("load", function () {
    a('[data-ride="carousel"]').each(function () {
      var c = a(this);b.call(c, c.data());
    });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    var c,
        d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");return a(d);
  }function c(b) {
    return this.each(function () {
      var c = a(this),
          e = c.data("bs.collapse"),
          f = a.extend({}, d.DEFAULTS, c.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b);!e && f.toggle && /show|hide/.test(b) && (f.toggle = !1), e || c.data("bs.collapse", e = new d(this, f)), "string" == typeof b && e[b]();
    });
  }var d = function d(b, c) {
    this.$element = a(b), this.options = a.extend({}, d.DEFAULTS, c), this.$trigger = a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle();
  };d.VERSION = "3.3.7", d.TRANSITION_DURATION = 350, d.DEFAULTS = { toggle: !0 }, d.prototype.dimension = function () {
    var a = this.$element.hasClass("width");return a ? "width" : "height";
  }, d.prototype.show = function () {
    if (!this.transitioning && !this.$element.hasClass("in")) {
      var b,
          e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");if (!(e && e.length && (b = e.data("bs.collapse"), b && b.transitioning))) {
        var f = a.Event("show.bs.collapse");if (this.$element.trigger(f), !f.isDefaultPrevented()) {
          e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));var g = this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;var h = function h() {
            this.$element.removeClass("collapsing").addClass("collapse in")[g](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse");
          };if (!a.support.transition) return h.call(this);var i = a.camelCase(["scroll", g].join("-"));this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i]);
        }
      }
    }
  }, d.prototype.hide = function () {
    if (!this.transitioning && this.$element.hasClass("in")) {
      var b = a.Event("hide.bs.collapse");if (this.$element.trigger(b), !b.isDefaultPrevented()) {
        var c = this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;var e = function e() {
          this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
        };return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this);
      }
    }
  }, d.prototype.toggle = function () {
    this[this.$element.hasClass("in") ? "hide" : "show"]();
  }, d.prototype.getParent = function () {
    return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function (c, d) {
      var e = a(d);this.addAriaAndCollapsedClass(b(e), e);
    }, this)).end();
  }, d.prototype.addAriaAndCollapsedClass = function (a, b) {
    var c = a.hasClass("in");a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c);
  };var e = a.fn.collapse;a.fn.collapse = c, a.fn.collapse.Constructor = d, a.fn.collapse.noConflict = function () {
    return a.fn.collapse = e, this;
  }, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function (d) {
    var e = a(this);e.attr("data-target") || d.preventDefault();var f = b(e),
        g = f.data("bs.collapse"),
        h = g ? "toggle" : e.data();c.call(f, h);
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    var c = b.attr("data-target");c || (c = b.attr("href"), c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, ""));var d = c && a(c);return d && d.length ? d : b.parent();
  }function c(c) {
    c && 3 === c.which || (a(e).remove(), a(f).each(function () {
      var d = a(this),
          e = b(d),
          f = { relatedTarget: this };e.hasClass("open") && (c && "click" == c.type && /input|textarea/i.test(c.target.tagName) && a.contains(e[0], c.target) || (e.trigger(c = a.Event("hide.bs.dropdown", f)), c.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger(a.Event("hidden.bs.dropdown", f)))));
    }));
  }function d(b) {
    return this.each(function () {
      var c = a(this),
          d = c.data("bs.dropdown");d || c.data("bs.dropdown", d = new g(this)), "string" == typeof b && d[b].call(c);
    });
  }var e = ".dropdown-backdrop",
      f = '[data-toggle="dropdown"]',
      g = function g(b) {
    a(b).on("click.bs.dropdown", this.toggle);
  };g.VERSION = "3.3.7", g.prototype.toggle = function (d) {
    var e = a(this);if (!e.is(".disabled, :disabled")) {
      var f = b(e),
          g = f.hasClass("open");if (c(), !g) {
        "ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click", c);var h = { relatedTarget: this };if (f.trigger(d = a.Event("show.bs.dropdown", h)), d.isDefaultPrevented()) return;e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
      }return !1;
    }
  }, g.prototype.keydown = function (c) {
    if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName)) {
      var d = a(this);if (c.preventDefault(), c.stopPropagation(), !d.is(".disabled, :disabled")) {
        var e = b(d),
            g = e.hasClass("open");if (!g && 27 != c.which || g && 27 == c.which) return 27 == c.which && e.find(f).trigger("focus"), d.trigger("click");var h = " li:not(.disabled):visible a",
            i = e.find(".dropdown-menu" + h);if (i.length) {
          var j = i.index(c.target);38 == c.which && j > 0 && j--, 40 == c.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus");
        }
      }
    }
  };var h = a.fn.dropdown;a.fn.dropdown = d, a.fn.dropdown.Constructor = g, a.fn.dropdown.noConflict = function () {
    return a.fn.dropdown = h, this;
  }, a(document).on("click.bs.dropdown.data-api", c).on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
    a.stopPropagation();
  }).on("click.bs.dropdown.data-api", f, g.prototype.toggle).on("keydown.bs.dropdown.data-api", f, g.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", g.prototype.keydown);
}(jQuery), +function (a) {
  "use strict";
  function b(b, d) {
    return this.each(function () {
      var e = a(this),
          f = e.data("bs.modal"),
          g = a.extend({}, c.DEFAULTS, e.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b);f || e.data("bs.modal", f = new c(this, g)), "string" == typeof b ? f[b](d) : g.show && f.show(d);
    });
  }var c = function c(b, _c2) {
    this.options = _c2, this.$body = a(document.body), this.$element = a(b), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function () {
      this.$element.trigger("loaded.bs.modal");
    }, this));
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 300, c.BACKDROP_TRANSITION_DURATION = 150, c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }, c.prototype.toggle = function (a) {
    return this.isShown ? this.hide() : this.show(a);
  }, c.prototype.show = function (b) {
    var d = this,
        e = a.Event("show.bs.modal", { relatedTarget: b });this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function () {
      d.$element.one("mouseup.dismiss.bs.modal", function (b) {
        a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
      });
    }), this.backdrop(function () {
      var e = a.support.transition && d.$element.hasClass("fade");d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in"), d.enforceFocus();var f = a.Event("shown.bs.modal", { relatedTarget: b });e ? d.$dialog.one("bsTransitionEnd", function () {
        d.$element.trigger("focus").trigger(f);
      }).emulateTransitionEnd(c.TRANSITION_DURATION) : d.$element.trigger("focus").trigger(f);
    }));
  }, c.prototype.hide = function (b) {
    b && b.preventDefault(), b = a.Event("hide.bs.modal"), this.$element.trigger(b), this.isShown && !b.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal());
  }, c.prototype.enforceFocus = function () {
    a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function (a) {
      document === a.target || this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus");
    }, this));
  }, c.prototype.escape = function () {
    this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function (a) {
      27 == a.which && this.hide();
    }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
  }, c.prototype.resize = function () {
    this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal");
  }, c.prototype.hideModal = function () {
    var a = this;this.$element.hide(), this.backdrop(function () {
      a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal");
    });
  }, c.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove(), this.$backdrop = null;
  }, c.prototype.backdrop = function (b) {
    var d = this,
        e = this.$element.hasClass("fade") ? "fade" : "";if (this.isShown && this.options.backdrop) {
      var f = a.support.transition && e;if (this.$backdrop = a(document.createElement("div")).addClass("modal-backdrop " + e).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", a.proxy(function (a) {
        return this.ignoreBackdropClick ? void (this.ignoreBackdropClick = !1) : void (a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()));
      }, this)), f && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !b) return;f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b();
    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass("in");var g = function g() {
        d.removeBackdrop(), b && b();
      };a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g();
    } else b && b();
  }, c.prototype.handleUpdate = function () {
    this.adjustDialog();
  }, c.prototype.adjustDialog = function () {
    var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;this.$element.css({ paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "", paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "" });
  }, c.prototype.resetAdjustments = function () {
    this.$element.css({ paddingLeft: "", paddingRight: "" });
  }, c.prototype.checkScrollbar = function () {
    var a = window.innerWidth;if (!a) {
      var b = document.documentElement.getBoundingClientRect();a = b.right - Math.abs(b.left);
    }this.bodyIsOverflowing = document.body.clientWidth < a, this.scrollbarWidth = this.measureScrollbar();
  }, c.prototype.setScrollbar = function () {
    var a = parseInt(this.$body.css("padding-right") || 0, 10);this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth);
  }, c.prototype.resetScrollbar = function () {
    this.$body.css("padding-right", this.originalBodyPad);
  }, c.prototype.measureScrollbar = function () {
    var a = document.createElement("div");a.className = "modal-scrollbar-measure", this.$body.append(a);var b = a.offsetWidth - a.clientWidth;return this.$body[0].removeChild(a), b;
  };var d = a.fn.modal;a.fn.modal = b, a.fn.modal.Constructor = c, a.fn.modal.noConflict = function () {
    return a.fn.modal = d, this;
  }, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (c) {
    var d = a(this),
        e = d.attr("href"),
        f = a(d.attr("data-target") || e && e.replace(/.*(?=#[^\s]+$)/, "")),
        g = f.data("bs.modal") ? "toggle" : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());d.is("a") && c.preventDefault(), f.one("show.bs.modal", function (a) {
      a.isDefaultPrevented() || f.one("hidden.bs.modal", function () {
        d.is(":visible") && d.trigger("focus");
      });
    }), b.call(f, g, this);
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.tooltip"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;!e && /destroy|hide/.test(b) || (e || d.data("bs.tooltip", e = new c(this, f)), "string" == typeof b && e[b]());
    });
  }var c = function c(a, b) {
    this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", a, b);
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 150, c.DEFAULTS = { animation: !0, placement: "top", selector: !1, template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', trigger: "hover focus", title: "", delay: 0, html: !1, container: !1, viewport: { selector: "body", padding: 0 } }, c.prototype.init = function (b, c, d) {
    if (this.enabled = !0, this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.$viewport = this.options.viewport && a(a.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = { click: !1, hover: !1, focus: !1 }, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");for (var e = this.options.trigger.split(" "), f = e.length; f--;) {
      var g = e[f];if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));else if ("manual" != g) {
        var h = "hover" == g ? "mouseenter" : "focusin",
            i = "hover" == g ? "mouseleave" : "focusout";this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this));
      }
    }this.options.selector ? this._options = a.extend({}, this.options, { trigger: "manual", selector: "" }) : this.fixTitle();
  }, c.prototype.getDefaults = function () {
    return c.DEFAULTS;
  }, c.prototype.getOptions = function (b) {
    return b = a.extend({}, this.getDefaults(), this.$element.data(), b), b.delay && "number" == typeof b.delay && (b.delay = { show: b.delay, hide: b.delay }), b;
  }, c.prototype.getDelegateOptions = function () {
    var b = {},
        c = this.getDefaults();return this._options && a.each(this._options, function (a, d) {
      c[a] != d && (b[a] = d);
    }), b;
  }, c.prototype.enter = function (b) {
    var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusin" == b.type ? "focus" : "hover"] = !0), c.tip().hasClass("in") || "in" == c.hoverState ? void (c.hoverState = "in") : (clearTimeout(c.timeout), c.hoverState = "in", c.options.delay && c.options.delay.show ? void (c.timeout = setTimeout(function () {
      "in" == c.hoverState && c.show();
    }, c.options.delay.show)) : c.show());
  }, c.prototype.isInStateTrue = function () {
    for (var a in this.inState) {
      if (this.inState[a]) return !0;
    }return !1;
  }, c.prototype.leave = function (b) {
    var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);if (c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusout" == b.type ? "focus" : "hover"] = !1), !c.isInStateTrue()) return clearTimeout(c.timeout), c.hoverState = "out", c.options.delay && c.options.delay.hide ? void (c.timeout = setTimeout(function () {
      "out" == c.hoverState && c.hide();
    }, c.options.delay.hide)) : c.hide();
  }, c.prototype.show = function () {
    var b = a.Event("show.bs." + this.type);if (this.hasContent() && this.enabled) {
      this.$element.trigger(b);var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);if (b.isDefaultPrevented() || !d) return;var e = this,
          f = this.tip(),
          g = this.getUID(this.type);this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
          i = /\s?auto?\s?/i,
          j = i.test(h);j && (h = h.replace(i, "") || "top"), f.detach().css({ top: 0, left: 0, display: "block" }).addClass(h).data("bs." + this.type, this), this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);var k = this.getPosition(),
          l = f[0].offsetWidth,
          m = f[0].offsetHeight;if (j) {
        var n = h,
            o = this.getPosition(this.$viewport);h = "bottom" == h && k.bottom + m > o.bottom ? "top" : "top" == h && k.top - m < o.top ? "bottom" : "right" == h && k.right + l > o.width ? "left" : "left" == h && k.left - l < o.left ? "right" : h, f.removeClass(n).addClass(h);
      }var p = this.getCalculatedOffset(h, k, l, m);this.applyPlacement(p, h);var q = function q() {
        var a = e.hoverState;e.$element.trigger("shown.bs." + e.type), e.hoverState = null, "out" == a && e.leave(e);
      };a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", q).emulateTransitionEnd(c.TRANSITION_DURATION) : q();
    }
  }, c.prototype.applyPlacement = function (b, c) {
    var d = this.tip(),
        e = d[0].offsetWidth,
        f = d[0].offsetHeight,
        g = parseInt(d.css("margin-top"), 10),
        h = parseInt(d.css("margin-left"), 10);isNaN(g) && (g = 0), isNaN(h) && (h = 0), b.top += g, b.left += h, a.offset.setOffset(d[0], a.extend({ using: function using(a) {
        d.css({ top: Math.round(a.top), left: Math.round(a.left) });
      } }, b), 0), d.addClass("in");var i = d[0].offsetWidth,
        j = d[0].offsetHeight;"top" == c && j != f && (b.top = b.top + f - j);var k = this.getViewportAdjustedDelta(c, b, i, j);k.left ? b.left += k.left : b.top += k.top;var l = /top|bottom/.test(c),
        m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
        n = l ? "offsetWidth" : "offsetHeight";d.offset(b), this.replaceArrow(m, d[0][n], l);
  }, c.prototype.replaceArrow = function (a, b, c) {
    this.arrow().css(c ? "left" : "top", 50 * (1 - a / b) + "%").css(c ? "top" : "left", "");
  }, c.prototype.setContent = function () {
    var a = this.tip(),
        b = this.getTitle();a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right");
  }, c.prototype.hide = function (b) {
    function d() {
      "in" != e.hoverState && f.detach(), e.$element && e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b();
    }var e = this,
        f = a(this.$tip),
        g = a.Event("hide.bs." + this.type);if (this.$element.trigger(g), !g.isDefaultPrevented()) return f.removeClass("in"), a.support.transition && f.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), this.hoverState = null, this;
  }, c.prototype.fixTitle = function () {
    var a = this.$element;(a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "");
  }, c.prototype.hasContent = function () {
    return this.getTitle();
  }, c.prototype.getPosition = function (b) {
    b = b || this.$element;var c = b[0],
        d = "BODY" == c.tagName,
        e = c.getBoundingClientRect();null == e.width && (e = a.extend({}, e, { width: e.right - e.left, height: e.bottom - e.top }));var f = window.SVGElement && c instanceof window.SVGElement,
        g = d ? { top: 0, left: 0 } : f ? null : b.offset(),
        h = { scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop() },
        i = d ? { width: a(window).width(), height: a(window).height() } : null;return a.extend({}, e, h, i, g);
  }, c.prototype.getCalculatedOffset = function (a, b, c, d) {
    return "bottom" == a ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 } : "top" == a ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 } : "left" == a ? { top: b.top + b.height / 2 - d / 2, left: b.left - c } : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
  }, c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
    var e = { top: 0, left: 0 };if (!this.$viewport) return e;var f = this.options.viewport && this.options.viewport.padding || 0,
        g = this.getPosition(this.$viewport);if (/right|left/.test(a)) {
      var h = b.top - f - g.scroll,
          i = b.top + f - g.scroll + d;h < g.top ? e.top = g.top - h : i > g.top + g.height && (e.top = g.top + g.height - i);
    } else {
      var j = b.left - f,
          k = b.left + f + c;j < g.left ? e.left = g.left - j : k > g.right && (e.left = g.left + g.width - k);
    }return e;
  }, c.prototype.getTitle = function () {
    var a,
        b = this.$element,
        c = this.options;return a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title);
  }, c.prototype.getUID = function (a) {
    do {
      a += ~~(1e6 * Math.random());
    } while (document.getElementById(a));return a;
  }, c.prototype.tip = function () {
    if (!this.$tip && (this.$tip = a(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");return this.$tip;
  }, c.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
  }, c.prototype.enable = function () {
    this.enabled = !0;
  }, c.prototype.disable = function () {
    this.enabled = !1;
  }, c.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  }, c.prototype.toggle = function (b) {
    var c = this;b && (c = a(b.currentTarget).data("bs." + this.type), c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c))), b ? (c.inState.click = !c.inState.click, c.isInStateTrue() ? c.enter(c) : c.leave(c)) : c.tip().hasClass("in") ? c.leave(c) : c.enter(c);
  }, c.prototype.destroy = function () {
    var a = this;clearTimeout(this.timeout), this.hide(function () {
      a.$element.off("." + a.type).removeData("bs." + a.type), a.$tip && a.$tip.detach(), a.$tip = null, a.$arrow = null, a.$viewport = null, a.$element = null;
    });
  };var d = a.fn.tooltip;a.fn.tooltip = b, a.fn.tooltip.Constructor = c, a.fn.tooltip.noConflict = function () {
    return a.fn.tooltip = d, this;
  };
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.popover"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;!e && /destroy|hide/.test(b) || (e || d.data("bs.popover", e = new c(this, f)), "string" == typeof b && e[b]());
    });
  }var c = function c(a, b) {
    this.init("popover", a, b);
  };if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");c.VERSION = "3.3.7", c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, { placement: "right", trigger: "click", content: "", template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>' }), c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype), c.prototype.constructor = c, c.prototype.getDefaults = function () {
    return c.DEFAULTS;
  }, c.prototype.setContent = function () {
    var a = this.tip(),
        b = this.getTitle(),
        c = this.getContent();a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof c ? "html" : "append" : "text"](c), a.removeClass("fade top bottom left right in"), a.find(".popover-title").html() || a.find(".popover-title").hide();
  }, c.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  }, c.prototype.getContent = function () {
    var a = this.$element,
        b = this.options;return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content);
  }, c.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".arrow");
  };var d = a.fn.popover;a.fn.popover = b, a.fn.popover.Constructor = c, a.fn.popover.noConflict = function () {
    return a.fn.popover = d, this;
  };
}(jQuery), +function (a) {
  "use strict";
  function b(c, d) {
    this.$body = a(document.body), this.$scrollElement = a(a(c).is(document.body) ? window : c), this.options = a.extend({}, b.DEFAULTS, d), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)), this.refresh(), this.process();
  }function c(c) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.scrollspy"),
          f = "object" == (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(c)) && c;e || d.data("bs.scrollspy", e = new b(this, f)), "string" == typeof c && e[c]();
    });
  }b.VERSION = "3.3.7", b.DEFAULTS = { offset: 10 }, b.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
  }, b.prototype.refresh = function () {
    var b = this,
        c = "offset",
        d = 0;this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), a.isWindow(this.$scrollElement[0]) || (c = "position", d = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function () {
      var b = a(this),
          e = b.data("target") || b.attr("href"),
          f = /^#./.test(e) && a(e);return f && f.length && f.is(":visible") && [[f[c]().top + d, e]] || null;
    }).sort(function (a, b) {
      return a[0] - b[0];
    }).each(function () {
      b.offsets.push(this[0]), b.targets.push(this[1]);
    });
  }, b.prototype.process = function () {
    var a,
        b = this.$scrollElement.scrollTop() + this.options.offset,
        c = this.getScrollHeight(),
        d = this.options.offset + c - this.$scrollElement.height(),
        e = this.offsets,
        f = this.targets,
        g = this.activeTarget;if (this.scrollHeight != c && this.refresh(), b >= d) return g != (a = f[f.length - 1]) && this.activate(a);if (g && b < e[0]) return this.activeTarget = null, this.clear();for (a = e.length; a--;) {
      g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a]);
    }
  }, b.prototype.activate = function (b) {
    this.activeTarget = b, this.clear();var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
        d = a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy");
  }, b.prototype.clear = function () {
    a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
  };var d = a.fn.scrollspy;a.fn.scrollspy = c, a.fn.scrollspy.Constructor = b, a.fn.scrollspy.noConflict = function () {
    return a.fn.scrollspy = d, this;
  }, a(window).on("load.bs.scrollspy.data-api", function () {
    a('[data-spy="scroll"]').each(function () {
      var b = a(this);c.call(b, b.data());
    });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.tab");e || d.data("bs.tab", e = new c(this)), "string" == typeof b && e[b]();
    });
  }var c = function c(b) {
    this.element = a(b);
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 150, c.prototype.show = function () {
    var b = this.element,
        c = b.closest("ul:not(.dropdown-menu)"),
        d = b.data("target");if (d || (d = b.attr("href"), d = d && d.replace(/.*(?=#[^\s]*$)/, "")), !b.parent("li").hasClass("active")) {
      var e = c.find(".active:last a"),
          f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
          g = a.Event("show.bs.tab", { relatedTarget: e[0] });if (e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented()) {
        var h = a(d);this.activate(b.closest("li"), c), this.activate(h, h.parent(), function () {
          e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }), b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
        });
      }
    }
  }, c.prototype.activate = function (b, d, e) {
    function f() {
      g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"), b.parent(".dropdown-menu").length && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), e && e();
    }var g = d.find("> .active"),
        h = e && a.support.transition && (g.length && g.hasClass("fade") || !!d.find("> .fade").length);g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in");
  };var d = a.fn.tab;a.fn.tab = b, a.fn.tab.Constructor = c, a.fn.tab.noConflict = function () {
    return a.fn.tab = d, this;
  };var e = function e(c) {
    c.preventDefault(), b.call(a(this), "show");
  };a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.affix"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;e || d.data("bs.affix", e = new c(this, f)), "string" == typeof b && e[b]();
    });
  }var c = function c(b, d) {
    this.options = a.extend({}, c.DEFAULTS, d), this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this)), this.$element = a(b), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition();
  };c.VERSION = "3.3.7", c.RESET = "affix affix-top affix-bottom", c.DEFAULTS = { offset: 0, target: window }, c.prototype.getState = function (a, b, c, d) {
    var e = this.$target.scrollTop(),
        f = this.$element.offset(),
        g = this.$target.height();if (null != c && "top" == this.affixed) return e < c && "top";if ("bottom" == this.affixed) return null != c ? !(e + this.unpin <= f.top) && "bottom" : !(e + g <= a - d) && "bottom";var h = null == this.affixed,
        i = h ? e : f.top,
        j = h ? g : b;return null != c && e <= c ? "top" : null != d && i + j >= a - d && "bottom";
  }, c.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a = this.$target.scrollTop(),
        b = this.$element.offset();return this.pinnedOffset = b.top - a;
  }, c.prototype.checkPositionWithEventLoop = function () {
    setTimeout(a.proxy(this.checkPosition, this), 1);
  }, c.prototype.checkPosition = function () {
    if (this.$element.is(":visible")) {
      var b = this.$element.height(),
          d = this.options.offset,
          e = d.top,
          f = d.bottom,
          g = Math.max(a(document).height(), a(document.body).height());"object" != (typeof d === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(d)) && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));var h = this.getState(g, b, e, f);if (this.affixed != h) {
        null != this.unpin && this.$element.css("top", "");var i = "affix" + (h ? "-" + h : ""),
            j = a.Event(i + ".bs.affix");if (this.$element.trigger(j), j.isDefaultPrevented()) return;this.affixed = h, this.unpin = "bottom" == h ? this.getPinnedOffset() : null, this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix", "affixed") + ".bs.affix");
      }"bottom" == h && this.$element.offset({ top: g - b - f });
    }
  };var d = a.fn.affix;a.fn.affix = b, a.fn.affix.Constructor = c, a.fn.affix.noConflict = function () {
    return a.fn.affix = d, this;
  }, a(window).on("load", function () {
    a('[data-spy="affix"]').each(function () {
      var c = a(this),
          d = c.data();d.offset = d.offset || {}, null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d);
    });
  });
}(jQuery);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set_immediate__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set_immediate__);


/*
 * jQuery FlexSlider v2.2.2
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */(function (e) {
  e.flexslider = function (t, n) {
    var r = e(t);r.vars = e.extend({}, e.flexslider.defaults, n);var i = r.vars.namespace,
        s = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
        o = ("ontouchstart" in window || s || window.DocumentTouch && document instanceof DocumentTouch) && r.vars.touch,
        u = "click touchend MSPointerUp",
        a = "",
        f,
        l = r.vars.direction === "vertical",
        c = r.vars.reverse,
        h = r.vars.itemWidth > 0,
        p = r.vars.animation === "fade",
        d = r.vars.asNavFor !== "",
        v = {},
        m = !0;e.data(t, "flexslider", r);v = { init: function init() {
        r.animating = !1;r.currentSlide = parseInt(r.vars.startAt ? r.vars.startAt : 0, 10);isNaN(r.currentSlide) && (r.currentSlide = 0);r.animatingTo = r.currentSlide;r.atEnd = r.currentSlide === 0 || r.currentSlide === r.last;r.containerSelector = r.vars.selector.substr(0, r.vars.selector.search(" "));r.slides = e(r.vars.selector, r);r.container = e(r.containerSelector, r);r.count = r.slides.length;r.syncExists = e(r.vars.sync).length > 0;r.vars.animation === "slide" && (r.vars.animation = "swing");r.prop = l ? "top" : "marginLeft";r.args = {};r.manualPause = !1;r.stopped = !1;r.started = !1;r.startTimeout = null;r.transitions = !r.vars.video && !p && r.vars.useCSS && function () {
          var e = document.createElement("div"),
              t = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];for (var n in t) {
            if (e.style[t[n]] !== undefined) {
              r.pfx = t[n].replace("Perspective", "").toLowerCase();r.prop = "-" + r.pfx + "-transform";return !0;
            }
          }return !1;
        }();r.vars.controlsContainer !== "" && (r.controlsContainer = e(r.vars.controlsContainer).length > 0 && e(r.vars.controlsContainer));r.vars.manualControls !== "" && (r.manualControls = e(r.vars.manualControls).length > 0 && e(r.vars.manualControls));if (r.vars.randomize) {
          r.slides.sort(function () {
            return Math.round(Math.random()) - .5;
          });r.container.empty().append(r.slides);
        }r.doMath();r.setup("init");r.vars.controlNav && v.controlNav.setup();r.vars.directionNav && v.directionNav.setup();r.vars.keyboard && (e(r.containerSelector).length === 1 || r.vars.multipleKeyboard) && e(document).bind("keyup", function (e) {
          var t = e.keyCode;if (!r.animating && (t === 39 || t === 37)) {
            var n = t === 39 ? r.getTarget("next") : t === 37 ? r.getTarget("prev") : !1;r.flexAnimate(n, r.vars.pauseOnAction);
          }
        });r.vars.mousewheel && r.bind("mousewheel", function (e, t, n, i) {
          e.preventDefault();var s = t < 0 ? r.getTarget("next") : r.getTarget("prev");r.flexAnimate(s, r.vars.pauseOnAction);
        });r.vars.pausePlay && v.pausePlay.setup();r.vars.slideshow && r.vars.pauseInvisible && v.pauseInvisible.init();if (r.vars.slideshow) {
          r.vars.pauseOnHover && r.hover(function () {
            !r.manualPlay && !r.manualPause && r.pause();
          }, function () {
            !r.manualPause && !r.manualPlay && !r.stopped && r.play();
          });if (!r.vars.pauseInvisible || !v.pauseInvisible.isHidden()) r.vars.initDelay > 0 ? r.startTimeout = setTimeout(r.play, r.vars.initDelay) : r.play();
        }d && v.asNav.setup();o && r.vars.touch && v.touch();(!p || p && r.vars.smoothHeight) && e(window).bind("resize orientationchange focus", v.resize);r.find("img").attr("draggable", "false");setTimeout(function () {
          r.vars.start(r);
        }, 200);
      }, asNav: { setup: function setup() {
          r.asNav = !0;r.animatingTo = Math.floor(r.currentSlide / r.move);r.currentItem = r.currentSlide;r.slides.removeClass(i + "active-slide").eq(r.currentItem).addClass(i + "active-slide");if (!s) r.slides.on(u, function (t) {
            t.preventDefault();var n = e(this),
                s = n.index(),
                o = n.offset().left - e(r).scrollLeft();if (o <= 0 && n.hasClass(i + "active-slide")) r.flexAnimate(r.getTarget("prev"), !0);else if (!e(r.vars.asNavFor).data("flexslider").animating && !n.hasClass(i + "active-slide")) {
              r.direction = r.currentItem < s ? "next" : "prev";r.flexAnimate(s, r.vars.pauseOnAction, !1, !0, !0);
            }
          });else {
            t._slider = r;r.slides.each(function () {
              var t = this;t._gesture = new MSGesture();t._gesture.target = t;t.addEventListener("MSPointerDown", function (e) {
                e.preventDefault();e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId);
              }, !1);t.addEventListener("MSGestureTap", function (t) {
                t.preventDefault();var n = e(this),
                    i = n.index();if (!e(r.vars.asNavFor).data("flexslider").animating && !n.hasClass("active")) {
                  r.direction = r.currentItem < i ? "next" : "prev";r.flexAnimate(i, r.vars.pauseOnAction, !1, !0, !0);
                }
              });
            });
          }
        } }, controlNav: { setup: function setup() {
          r.manualControls ? v.controlNav.setupManual() : v.controlNav.setupPaging();
        }, setupPaging: function setupPaging() {
          var t = r.vars.controlNav === "thumbnails" ? "control-thumbs" : "control-paging",
              n = 1,
              s,
              o;r.controlNavScaffold = e('<ol class="' + i + "control-nav " + i + t + '"></ol>');if (r.pagingCount > 1) for (var f = 0; f < r.pagingCount; f++) {
            o = r.slides.eq(f);s = r.vars.controlNav === "thumbnails" ? '<img src="' + o.attr("data-thumb") + '"/>' : "<a>" + n + "</a>";if ("thumbnails" === r.vars.controlNav && !0 === r.vars.thumbCaptions) {
              var l = o.attr("data-thumbcaption");"" != l && undefined != l && (s += '<span class="' + i + 'caption">' + l + "</span>");
            }r.controlNavScaffold.append("<li>" + s + "</li>");n++;
          }r.controlsContainer ? e(r.controlsContainer).append(r.controlNavScaffold) : r.append(r.controlNavScaffold);v.controlNav.set();v.controlNav.active();r.controlNavScaffold.delegate("a, img", u, function (t) {
            t.preventDefault();if (a === "" || a === t.type) {
              var n = e(this),
                  s = r.controlNav.index(n);if (!n.hasClass(i + "active")) {
                r.direction = s > r.currentSlide ? "next" : "prev";r.flexAnimate(s, r.vars.pauseOnAction);
              }
            }a === "" && (a = t.type);v.setToClearWatchedEvent();
          });
        }, setupManual: function setupManual() {
          r.controlNav = r.manualControls;v.controlNav.active();r.controlNav.bind(u, function (t) {
            t.preventDefault();if (a === "" || a === t.type) {
              var n = e(this),
                  s = r.controlNav.index(n);if (!n.hasClass(i + "active")) {
                s > r.currentSlide ? r.direction = "next" : r.direction = "prev";r.flexAnimate(s, r.vars.pauseOnAction);
              }
            }a === "" && (a = t.type);v.setToClearWatchedEvent();
          });
        }, set: function set() {
          var t = r.vars.controlNav === "thumbnails" ? "img" : "a";r.controlNav = e("." + i + "control-nav li " + t, r.controlsContainer ? r.controlsContainer : r);
        }, active: function active() {
          r.controlNav.removeClass(i + "active").eq(r.animatingTo).addClass(i + "active");
        }, update: function update(t, n) {
          r.pagingCount > 1 && t === "add" ? r.controlNavScaffold.append(e("<li><a>" + r.count + "</a></li>")) : r.pagingCount === 1 ? r.controlNavScaffold.find("li").remove() : r.controlNav.eq(n).closest("li").remove();v.controlNav.set();r.pagingCount > 1 && r.pagingCount !== r.controlNav.length ? r.update(n, t) : v.controlNav.active();
        } }, directionNav: { setup: function setup() {
          var t = e('<ul class="' + i + 'direction-nav"><li><a class="' + i + 'prev" href="#">' + r.vars.prevText + '</a></li><li><a class="' + i + 'next" href="#">' + r.vars.nextText + "</a></li></ul>");if (r.controlsContainer) {
            e(r.controlsContainer).append(t);r.directionNav = e("." + i + "direction-nav li a", r.controlsContainer);
          } else {
            r.append(t);r.directionNav = e("." + i + "direction-nav li a", r);
          }v.directionNav.update();r.directionNav.bind(u, function (t) {
            t.preventDefault();var n;if (a === "" || a === t.type) {
              n = e(this).hasClass(i + "next") ? r.getTarget("next") : r.getTarget("prev");r.flexAnimate(n, r.vars.pauseOnAction);
            }a === "" && (a = t.type);v.setToClearWatchedEvent();
          });
        }, update: function update() {
          var e = i + "disabled";r.pagingCount === 1 ? r.directionNav.addClass(e).attr("tabindex", "-1") : r.vars.animationLoop ? r.directionNav.removeClass(e).removeAttr("tabindex") : r.animatingTo === 0 ? r.directionNav.removeClass(e).filter("." + i + "prev").addClass(e).attr("tabindex", "-1") : r.animatingTo === r.last ? r.directionNav.removeClass(e).filter("." + i + "next").addClass(e).attr("tabindex", "-1") : r.directionNav.removeClass(e).removeAttr("tabindex");
        } }, pausePlay: { setup: function setup() {
          var t = e('<div class="' + i + 'pauseplay"><a></a></div>');if (r.controlsContainer) {
            r.controlsContainer.append(t);r.pausePlay = e("." + i + "pauseplay a", r.controlsContainer);
          } else {
            r.append(t);r.pausePlay = e("." + i + "pauseplay a", r);
          }v.pausePlay.update(r.vars.slideshow ? i + "pause" : i + "play");r.pausePlay.bind(u, function (t) {
            t.preventDefault();if (a === "" || a === t.type) if (e(this).hasClass(i + "pause")) {
              r.manualPause = !0;r.manualPlay = !1;r.pause();
            } else {
              r.manualPause = !1;r.manualPlay = !0;r.play();
            }a === "" && (a = t.type);v.setToClearWatchedEvent();
          });
        }, update: function update(e) {
          e === "play" ? r.pausePlay.removeClass(i + "pause").addClass(i + "play").html(r.vars.playText) : r.pausePlay.removeClass(i + "play").addClass(i + "pause").html(r.vars.pauseText);
        } }, touch: function touch() {
        var e,
            n,
            i,
            o,
            u,
            a,
            f = !1,
            d = 0,
            v = 0,
            m = 0;if (!s) {
          var g = function g(s) {
            if (r.animating) s.preventDefault();else if (window.navigator.msPointerEnabled || s.touches.length === 1) {
              r.pause();o = l ? r.h : r.w;a = Number(new Date());d = s.touches[0].pageX;v = s.touches[0].pageY;i = h && c && r.animatingTo === r.last ? 0 : h && c ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : h && r.currentSlide === r.last ? r.limit : h ? (r.itemW + r.vars.itemMargin) * r.move * r.currentSlide : c ? (r.last - r.currentSlide + r.cloneOffset) * o : (r.currentSlide + r.cloneOffset) * o;e = l ? v : d;n = l ? d : v;t.addEventListener("touchmove", y, !1);t.addEventListener("touchend", b, !1);
            }
          };

          var y = function y(t) {
            d = t.touches[0].pageX;v = t.touches[0].pageY;u = l ? e - v : e - d;f = l ? Math.abs(u) < Math.abs(d - n) : Math.abs(u) < Math.abs(v - n);var s = 500;if (!f || Number(new Date()) - a > s) {
              t.preventDefault();if (!p && r.transitions) {
                r.vars.animationLoop || (u /= r.currentSlide === 0 && u < 0 || r.currentSlide === r.last && u > 0 ? Math.abs(u) / o + 2 : 1);r.setProps(i + u, "setTouch");
              }
            }
          };

          var b = function b(s) {
            t.removeEventListener("touchmove", y, !1);if (r.animatingTo === r.currentSlide && !f && u !== null) {
              var l = c ? -u : u,
                  h = l > 0 ? r.getTarget("next") : r.getTarget("prev");r.canAdvance(h) && (Number(new Date()) - a < 550 && Math.abs(l) > 50 || Math.abs(l) > o / 2) ? r.flexAnimate(h, r.vars.pauseOnAction) : p || r.flexAnimate(r.currentSlide, r.vars.pauseOnAction, !0);
            }t.removeEventListener("touchend", b, !1);e = null;n = null;u = null;i = null;
          };

          t.addEventListener("touchstart", g, !1);
        } else {
          var w = function w(e) {
            e.stopPropagation();if (r.animating) e.preventDefault();else {
              r.pause();t._gesture.addPointer(e.pointerId);m = 0;o = l ? r.h : r.w;a = Number(new Date());i = h && c && r.animatingTo === r.last ? 0 : h && c ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : h && r.currentSlide === r.last ? r.limit : h ? (r.itemW + r.vars.itemMargin) * r.move * r.currentSlide : c ? (r.last - r.currentSlide + r.cloneOffset) * o : (r.currentSlide + r.cloneOffset) * o;
            }
          };

          var E = function E(e) {
            e.stopPropagation();var n = e.target._slider;if (!n) return;var r = -e.translationX,
                s = -e.translationY;m += l ? s : r;u = m;f = l ? Math.abs(m) < Math.abs(-r) : Math.abs(m) < Math.abs(-s);if (e.detail === e.MSGESTURE_FLAG_INERTIA) {
              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set_immediate___default()(function () {
                t._gesture.stop();
              });return;
            }if (!f || Number(new Date()) - a > 500) {
              e.preventDefault();if (!p && n.transitions) {
                n.vars.animationLoop || (u = m / (n.currentSlide === 0 && m < 0 || n.currentSlide === n.last && m > 0 ? Math.abs(m) / o + 2 : 1));n.setProps(i + u, "setTouch");
              }
            }
          };

          var S = function S(t) {
            t.stopPropagation();var r = t.target._slider;if (!r) return;if (r.animatingTo === r.currentSlide && !f && u !== null) {
              var s = c ? -u : u,
                  l = s > 0 ? r.getTarget("next") : r.getTarget("prev");r.canAdvance(l) && (Number(new Date()) - a < 550 && Math.abs(s) > 50 || Math.abs(s) > o / 2) ? r.flexAnimate(l, r.vars.pauseOnAction) : p || r.flexAnimate(r.currentSlide, r.vars.pauseOnAction, !0);
            }e = null;n = null;u = null;i = null;m = 0;
          };

          t.style.msTouchAction = "none";t._gesture = new MSGesture();t._gesture.target = t;t.addEventListener("MSPointerDown", w, !1);t._slider = r;t.addEventListener("MSGestureChange", E, !1);t.addEventListener("MSGestureEnd", S, !1);
        }
      }, resize: function resize() {
        if (!r.animating && r.is(":visible")) {
          h || r.doMath();if (p) v.smoothHeight();else if (h) {
            r.slides.width(r.computedW);r.update(r.pagingCount);r.setProps();
          } else if (l) {
            r.viewport.height(r.h);r.setProps(r.h, "setTotal");
          } else {
            r.vars.smoothHeight && v.smoothHeight();r.newSlides.width(r.computedW);r.setProps(r.computedW, "setTotal");
          }
        }
      }, smoothHeight: function smoothHeight(e) {
        if (!l || p) {
          var t = p ? r : r.viewport;e ? t.animate({ height: r.slides.eq(r.animatingTo).height() }, e) : t.height(r.slides.eq(r.animatingTo).height());
        }
      }, sync: function sync(t) {
        var n = e(r.vars.sync).data("flexslider"),
            i = r.animatingTo;switch (t) {case "animate":
            n.flexAnimate(i, r.vars.pauseOnAction, !1, !0);break;case "play":
            !n.playing && !n.asNav && n.play();break;case "pause":
            n.pause();}
      }, uniqueID: function uniqueID(t) {
        t.find("[id]").each(function () {
          var t = e(this);t.attr("id", t.attr("id") + "_clone");
        });return t;
      }, pauseInvisible: { visProp: null, init: function init() {
          var e = ["webkit", "moz", "ms", "o"];if ("hidden" in document) return "hidden";for (var t = 0; t < e.length; t++) {
            e[t] + "Hidden" in document && (v.pauseInvisible.visProp = e[t] + "Hidden");
          }if (v.pauseInvisible.visProp) {
            var n = v.pauseInvisible.visProp.replace(/[H|h]idden/, "") + "visibilitychange";document.addEventListener(n, function () {
              v.pauseInvisible.isHidden() ? r.startTimeout ? clearTimeout(r.startTimeout) : r.pause() : r.started ? r.play() : r.vars.initDelay > 0 ? setTimeout(r.play, r.vars.initDelay) : r.play();
            });
          }
        }, isHidden: function isHidden() {
          return document[v.pauseInvisible.visProp] || !1;
        } }, setToClearWatchedEvent: function setToClearWatchedEvent() {
        clearTimeout(f);f = setTimeout(function () {
          a = "";
        }, 3e3);
      } };r.flexAnimate = function (t, n, s, u, a) {
      !r.vars.animationLoop && t !== r.currentSlide && (r.direction = t > r.currentSlide ? "next" : "prev");d && r.pagingCount === 1 && (r.direction = r.currentItem < t ? "next" : "prev");if (!r.animating && (r.canAdvance(t, a) || s) && r.is(":visible")) {
        if (d && u) {
          var f = e(r.vars.asNavFor).data("flexslider");r.atEnd = t === 0 || t === r.count - 1;f.flexAnimate(t, !0, !1, !0, a);r.direction = r.currentItem < t ? "next" : "prev";f.direction = r.direction;if (Math.ceil((t + 1) / r.visible) - 1 === r.currentSlide || t === 0) {
            r.currentItem = t;r.slides.removeClass(i + "active-slide").eq(t).addClass(i + "active-slide");return !1;
          }r.currentItem = t;r.slides.removeClass(i + "active-slide").eq(t).addClass(i + "active-slide");t = Math.floor(t / r.visible);
        }r.animating = !0;r.animatingTo = t;n && r.pause();r.vars.before(r);r.syncExists && !a && v.sync("animate");r.vars.controlNav && v.controlNav.active();h || r.slides.removeClass(i + "active-slide").eq(t).addClass(i + "active-slide");r.atEnd = t === 0 || t === r.last;r.vars.directionNav && v.directionNav.update();if (t === r.last) {
          r.vars.end(r);r.vars.animationLoop || r.pause();
        }if (!p) {
          var m = l ? r.slides.filter(":first").height() : r.computedW,
              g,
              y,
              b;if (h) {
            g = r.vars.itemMargin;b = (r.itemW + g) * r.move * r.animatingTo;y = b > r.limit && r.visible !== 1 ? r.limit : b;
          } else r.currentSlide === 0 && t === r.count - 1 && r.vars.animationLoop && r.direction !== "next" ? y = c ? (r.count + r.cloneOffset) * m : 0 : r.currentSlide === r.last && t === 0 && r.vars.animationLoop && r.direction !== "prev" ? y = c ? 0 : (r.count + 1) * m : y = c ? (r.count - 1 - t + r.cloneOffset) * m : (t + r.cloneOffset) * m;r.setProps(y, "", r.vars.animationSpeed);if (r.transitions) {
            if (!r.vars.animationLoop || !r.atEnd) {
              r.animating = !1;r.currentSlide = r.animatingTo;
            }r.container.unbind("webkitTransitionEnd transitionend");r.container.bind("webkitTransitionEnd transitionend", function () {
              r.wrapup(m);
            });
          } else r.container.animate(r.args, r.vars.animationSpeed, r.vars.easing, function () {
            r.wrapup(m);
          });
        } else if (!o) {
          r.slides.eq(r.currentSlide).css({ zIndex: 1 }).animate({ opacity: 0 }, r.vars.animationSpeed, r.vars.easing);r.slides.eq(t).css({ zIndex: 2 }).animate({ opacity: 1 }, r.vars.animationSpeed, r.vars.easing, r.wrapup);
        } else {
          r.slides.eq(r.currentSlide).css({ opacity: 0, zIndex: 1 });r.slides.eq(t).css({ opacity: 1, zIndex: 2 });r.wrapup(m);
        }r.vars.smoothHeight && v.smoothHeight(r.vars.animationSpeed);
      }
    };r.wrapup = function (e) {
      !p && !h && (r.currentSlide === 0 && r.animatingTo === r.last && r.vars.animationLoop ? r.setProps(e, "jumpEnd") : r.currentSlide === r.last && r.animatingTo === 0 && r.vars.animationLoop && r.setProps(e, "jumpStart"));r.animating = !1;r.currentSlide = r.animatingTo;r.vars.after(r);
    };r.animateSlides = function () {
      !r.animating && m && r.flexAnimate(r.getTarget("next"));
    };r.pause = function () {
      clearInterval(r.animatedSlides);r.animatedSlides = null;r.playing = !1;r.vars.pausePlay && v.pausePlay.update("play");r.syncExists && v.sync("pause");
    };r.play = function () {
      r.playing && clearInterval(r.animatedSlides);r.animatedSlides = r.animatedSlides || setInterval(r.animateSlides, r.vars.slideshowSpeed);r.started = r.playing = !0;r.vars.pausePlay && v.pausePlay.update("pause");r.syncExists && v.sync("play");
    };r.stop = function () {
      r.pause();r.stopped = !0;
    };r.canAdvance = function (e, t) {
      var n = d ? r.pagingCount - 1 : r.last;return t ? !0 : d && r.currentItem === r.count - 1 && e === 0 && r.direction === "prev" ? !0 : d && r.currentItem === 0 && e === r.pagingCount - 1 && r.direction !== "next" ? !1 : e === r.currentSlide && !d ? !1 : r.vars.animationLoop ? !0 : r.atEnd && r.currentSlide === 0 && e === n && r.direction !== "next" ? !1 : r.atEnd && r.currentSlide === n && e === 0 && r.direction === "next" ? !1 : !0;
    };r.getTarget = function (e) {
      r.direction = e;return e === "next" ? r.currentSlide === r.last ? 0 : r.currentSlide + 1 : r.currentSlide === 0 ? r.last : r.currentSlide - 1;
    };r.setProps = function (e, t, n) {
      var i = function () {
        var n = e ? e : (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo,
            i = function () {
          if (h) return t === "setTouch" ? e : c && r.animatingTo === r.last ? 0 : c ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : r.animatingTo === r.last ? r.limit : n;switch (t) {case "setTotal":
              return c ? (r.count - 1 - r.currentSlide + r.cloneOffset) * e : (r.currentSlide + r.cloneOffset) * e;case "setTouch":
              return c ? e : e;case "jumpEnd":
              return c ? e : r.count * e;case "jumpStart":
              return c ? r.count * e : e;default:
              return e;}
        }();return i * -1 + "px";
      }();if (r.transitions) {
        i = l ? "translate3d(0," + i + ",0)" : "translate3d(" + i + ",0,0)";n = n !== undefined ? n / 1e3 + "s" : "0s";r.container.css("-" + r.pfx + "-transition-duration", n);r.container.css("transition-duration", n);
      }r.args[r.prop] = i;(r.transitions || n === undefined) && r.container.css(r.args);r.container.css("transform", i);
    };r.setup = function (t) {
      if (!p) {
        var n, s;if (t === "init") {
          r.viewport = e('<div class="' + i + 'viewport"></div>').css({ overflow: "hidden", position: "relative" }).appendTo(r).append(r.container);r.cloneCount = 0;r.cloneOffset = 0;if (c) {
            s = e.makeArray(r.slides).reverse();r.slides = e(s);r.container.empty().append(r.slides);
          }
        }if (r.vars.animationLoop && !h) {
          r.cloneCount = 2;r.cloneOffset = 1;t !== "init" && r.container.find(".clone").remove();r.container.append(r.slides.first().clone().addClass("clone").attr("aria-hidden", "true")).prepend(r.slides.last().clone().addClass("clone").attr("aria-hidden", "true"));v.uniqueID(r.slides.first().clone().addClass("clone")).appendTo(r.container);v.uniqueID(r.slides.last().clone().addClass("clone")).prependTo(r.container);
        }r.newSlides = e(r.vars.selector, r);n = c ? r.count - 1 - r.currentSlide + r.cloneOffset : r.currentSlide + r.cloneOffset;if (l && !h) {
          r.container.height((r.count + r.cloneCount) * 200 + "%").css("position", "absolute").width("100%");setTimeout(function () {
            r.newSlides.css({ display: "block" });r.doMath();r.viewport.height(r.h);r.setProps(n * r.h, "init");
          }, t === "init" ? 100 : 0);
        } else {
          r.container.width((r.count + r.cloneCount) * 200 + "%");r.setProps(n * r.computedW, "init");setTimeout(function () {
            r.doMath();r.newSlides.css({ width: r.computedW, "float": "left", display: "block" });r.vars.smoothHeight && v.smoothHeight();
          }, t === "init" ? 100 : 0);
        }
      } else {
        r.slides.css({ width: "100%", "float": "left", marginRight: "-100%", position: "relative" });t === "init" && (o ? r.slides.css({ opacity: 0, display: "block", webkitTransition: "opacity " + r.vars.animationSpeed / 1e3 + "s ease", zIndex: 1 }).eq(r.currentSlide).css({ opacity: 1, zIndex: 2 }) : r.slides.css({ opacity: 0, display: "block", zIndex: 1 }).eq(r.currentSlide).css({ zIndex: 2 }).animate({ opacity: 1 }, r.vars.animationSpeed, r.vars.easing));r.vars.smoothHeight && v.smoothHeight();
      }h || r.slides.removeClass(i + "active-slide").eq(r.currentSlide).addClass(i + "active-slide");r.vars.init(r);
    };r.doMath = function () {
      var e = r.slides.first(),
          t = r.vars.itemMargin,
          n = r.vars.minItems,
          i = r.vars.maxItems;r.w = r.viewport === undefined ? r.width() : r.viewport.width();r.h = e.height();r.boxPadding = e.outerWidth() - e.width();if (h) {
        r.itemT = r.vars.itemWidth + t;r.minW = n ? n * r.itemT : r.w;r.maxW = i ? i * r.itemT - t : r.w;r.itemW = r.minW > r.w ? (r.w - t * (n - 1)) / n : r.maxW < r.w ? (r.w - t * (i - 1)) / i : r.vars.itemWidth > r.w ? r.w : r.vars.itemWidth;r.visible = Math.floor(r.w / r.itemW);r.move = r.vars.move > 0 && r.vars.move < r.visible ? r.vars.move : r.visible;r.pagingCount = Math.ceil((r.count - r.visible) / r.move + 1);r.last = r.pagingCount - 1;r.limit = r.pagingCount === 1 ? 0 : r.vars.itemWidth > r.w ? r.itemW * (r.count - 1) + t * (r.count - 1) : (r.itemW + t) * r.count - r.w - t;
      } else {
        r.itemW = r.w;r.pagingCount = r.count;r.last = r.count - 1;
      }r.computedW = r.itemW - r.boxPadding;
    };r.update = function (e, t) {
      r.doMath();if (!h) {
        e < r.currentSlide ? r.currentSlide += 1 : e <= r.currentSlide && e !== 0 && (r.currentSlide -= 1);r.animatingTo = r.currentSlide;
      }if (r.vars.controlNav && !r.manualControls) if (t === "add" && !h || r.pagingCount > r.controlNav.length) v.controlNav.update("add");else if (t === "remove" && !h || r.pagingCount < r.controlNav.length) {
        if (h && r.currentSlide > r.last) {
          r.currentSlide -= 1;r.animatingTo -= 1;
        }v.controlNav.update("remove", r.last);
      }r.vars.directionNav && v.directionNav.update();
    };r.addSlide = function (t, n) {
      var i = e(t);r.count += 1;r.last = r.count - 1;l && c ? n !== undefined ? r.slides.eq(r.count - n).after(i) : r.container.prepend(i) : n !== undefined ? r.slides.eq(n).before(i) : r.container.append(i);r.update(n, "add");r.slides = e(r.vars.selector + ":not(.clone)", r);r.setup();r.vars.added(r);
    };r.removeSlide = function (t) {
      var n = isNaN(t) ? r.slides.index(e(t)) : t;r.count -= 1;r.last = r.count - 1;isNaN(t) ? e(t, r.slides).remove() : l && c ? r.slides.eq(r.last).remove() : r.slides.eq(t).remove();r.doMath();r.update(n, "remove");r.slides = e(r.vars.selector + ":not(.clone)", r);r.setup();r.vars.removed(r);
    };v.init();
  };e(window).blur(function (e) {
    focused = !1;
  }).focus(function (e) {
    focused = !0;
  });e.flexslider.defaults = { namespace: "flex-", selector: ".slides > li", animation: "fade", easing: "swing", direction: "horizontal", reverse: !1, animationLoop: !0, smoothHeight: !1, startAt: 0, slideshow: !0, slideshowSpeed: 7e3, animationSpeed: 600, initDelay: 0, randomize: !1, thumbCaptions: !1, pauseOnAction: !0, pauseOnHover: !1, pauseInvisible: !0, useCSS: !0, touch: !0, video: !1, controlNav: !0, directionNav: !0, prevText: "Previous", nextText: "Next", keyboard: !0, multipleKeyboard: !1, mousewheel: !1, pausePlay: !1, pauseText: "Pause", playText: "Play", controlsContainer: "", manualControls: "", sync: "", asNavFor: "", itemWidth: 0, itemMargin: 0, minItems: 1, maxItems: 0, move: 0, allowOneSlide: !0, start: function start() {}, before: function before() {}, after: function after() {}, end: function end() {}, added: function added() {}, removed: function removed() {}, init: function init() {} };e.fn.flexslider = function (t) {
    t === undefined && (t = {});if ((typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(t)) == "object") return this.each(function () {
      var n = e(this),
          r = t.selector ? t.selector : ".slides > li",
          i = n.find(r);if (i.length === 1 && t.allowOneSlide === !0 || i.length === 0) {
        i.fadeIn(400);t.start && t.start(n);
      } else n.data("flexslider") === undefined && new e.flexslider(this, t);
    });var n = e(this).data("flexslider");switch (t) {case "play":
        n.play();break;case "pause":
        n.pause();break;case "stop":
        n.stop();break;case "next":
        n.flexAnimate(n.getTarget("next"), !0);break;case "prev":case "previous":
        n.flexAnimate(n.getTarget("prev"), !0);break;default:
        typeof t == "number" && n.flexAnimate(t, !0);}
  };
})(jQuery);(function (e) {
  e.flexslider = function (t, n) {
    var r = e(t);r.vars = e.extend({}, e.flexslider.defaults, n);var i = r.vars.namespace,
        s = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
        o = ("ontouchstart" in window || s || window.DocumentTouch && document instanceof DocumentTouch) && r.vars.touch,
        u = "click touchend MSPointerUp",
        a = "",
        f,
        l = r.vars.direction === "vertical",
        c = r.vars.reverse,
        h = r.vars.itemWidth > 0,
        p = r.vars.animation === "fade",
        d = r.vars.asNavFor !== "",
        v = {},
        m = !0;e.data(t, "flexslider", r);v = { init: function init() {
        r.animating = !1;r.currentSlide = parseInt(r.vars.startAt ? r.vars.startAt : 0, 10);isNaN(r.currentSlide) && (r.currentSlide = 0);r.animatingTo = r.currentSlide;r.atEnd = r.currentSlide === 0 || r.currentSlide === r.last;r.containerSelector = r.vars.selector.substr(0, r.vars.selector.search(" "));r.slides = e(r.vars.selector, r);r.container = e(r.containerSelector, r);r.count = r.slides.length;r.syncExists = e(r.vars.sync).length > 0;r.vars.animation === "slide" && (r.vars.animation = "swing");r.prop = l ? "top" : "marginLeft";r.args = {};r.manualPause = !1;r.stopped = !1;r.started = !1;r.startTimeout = null;r.transitions = !r.vars.video && !p && r.vars.useCSS && function () {
          var e = document.createElement("div"),
              t = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];for (var n in t) {
            if (e.style[t[n]] !== undefined) {
              r.pfx = t[n].replace("Perspective", "").toLowerCase();r.prop = "-" + r.pfx + "-transform";return !0;
            }
          }return !1;
        }();r.vars.controlsContainer !== "" && (r.controlsContainer = e(r.vars.controlsContainer).length > 0 && e(r.vars.controlsContainer));r.vars.manualControls !== "" && (r.manualControls = e(r.vars.manualControls).length > 0 && e(r.vars.manualControls));if (r.vars.randomize) {
          r.slides.sort(function () {
            return Math.round(Math.random()) - .5;
          });r.container.empty().append(r.slides);
        }r.doMath();r.setup("init");r.vars.controlNav && v.controlNav.setup();r.vars.directionNav && v.directionNav.setup();r.vars.keyboard && (e(r.containerSelector).length === 1 || r.vars.multipleKeyboard) && e(document).bind("keyup", function (e) {
          var t = e.keyCode;if (!r.animating && (t === 39 || t === 37)) {
            var n = t === 39 ? r.getTarget("next") : t === 37 ? r.getTarget("prev") : !1;r.flexAnimate(n, r.vars.pauseOnAction);
          }
        });r.vars.mousewheel && r.bind("mousewheel", function (e, t, n, i) {
          e.preventDefault();var s = t < 0 ? r.getTarget("next") : r.getTarget("prev");r.flexAnimate(s, r.vars.pauseOnAction);
        });r.vars.pausePlay && v.pausePlay.setup();r.vars.slideshow && r.vars.pauseInvisible && v.pauseInvisible.init();if (r.vars.slideshow) {
          r.vars.pauseOnHover && r.hover(function () {
            !r.manualPlay && !r.manualPause && r.pause();
          }, function () {
            !r.manualPause && !r.manualPlay && !r.stopped && r.play();
          });if (!r.vars.pauseInvisible || !v.pauseInvisible.isHidden()) r.vars.initDelay > 0 ? r.startTimeout = setTimeout(r.play, r.vars.initDelay) : r.play();
        }d && v.asNav.setup();o && r.vars.touch && v.touch();(!p || p && r.vars.smoothHeight) && e(window).bind("resize orientationchange focus", v.resize);r.find("img").attr("draggable", "false");setTimeout(function () {
          r.vars.start(r);
        }, 200);
      }, asNav: { setup: function setup() {
          r.asNav = !0;r.animatingTo = Math.floor(r.currentSlide / r.move);r.currentItem = r.currentSlide;r.slides.removeClass(i + "active-slide").eq(r.currentItem).addClass(i + "active-slide");if (!s) r.slides.on(u, function (t) {
            t.preventDefault();var n = e(this),
                s = n.index(),
                o = n.offset().left - e(r).scrollLeft();if (o <= 0 && n.hasClass(i + "active-slide")) r.flexAnimate(r.getTarget("prev"), !0);else if (!e(r.vars.asNavFor).data("flexslider").animating && !n.hasClass(i + "active-slide")) {
              r.direction = r.currentItem < s ? "next" : "prev";r.flexAnimate(s, r.vars.pauseOnAction, !1, !0, !0);
            }
          });else {
            t._slider = r;r.slides.each(function () {
              var t = this;t._gesture = new MSGesture();t._gesture.target = t;t.addEventListener("MSPointerDown", function (e) {
                e.preventDefault();e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId);
              }, !1);t.addEventListener("MSGestureTap", function (t) {
                t.preventDefault();var n = e(this),
                    i = n.index();if (!e(r.vars.asNavFor).data("flexslider").animating && !n.hasClass("active")) {
                  r.direction = r.currentItem < i ? "next" : "prev";r.flexAnimate(i, r.vars.pauseOnAction, !1, !0, !0);
                }
              });
            });
          }
        } }, controlNav: { setup: function setup() {
          r.manualControls ? v.controlNav.setupManual() : v.controlNav.setupPaging();
        }, setupPaging: function setupPaging() {
          var t = r.vars.controlNav === "thumbnails" ? "control-thumbs" : "control-paging",
              n = 1,
              s,
              o;r.controlNavScaffold = e('<ol class="' + i + "control-nav " + i + t + '"></ol>');if (r.pagingCount > 1) for (var f = 0; f < r.pagingCount; f++) {
            o = r.slides.eq(f);s = r.vars.controlNav === "thumbnails" ? '<img src="' + o.attr("data-thumb") + '"/>' : "<a>" + n + "</a>";if ("thumbnails" === r.vars.controlNav && !0 === r.vars.thumbCaptions) {
              var l = o.attr("data-thumbcaption");"" != l && undefined != l && (s += '<span class="' + i + 'caption">' + l + "</span>");
            }r.controlNavScaffold.append("<li>" + s + "</li>");n++;
          }r.controlsContainer ? e(r.controlsContainer).append(r.controlNavScaffold) : r.append(r.controlNavScaffold);v.controlNav.set();v.controlNav.active();r.controlNavScaffold.delegate("a, img", u, function (t) {
            t.preventDefault();if (a === "" || a === t.type) {
              var n = e(this),
                  s = r.controlNav.index(n);if (!n.hasClass(i + "active")) {
                r.direction = s > r.currentSlide ? "next" : "prev";r.flexAnimate(s, r.vars.pauseOnAction);
              }
            }a === "" && (a = t.type);v.setToClearWatchedEvent();
          });
        }, setupManual: function setupManual() {
          r.controlNav = r.manualControls;v.controlNav.active();r.controlNav.bind(u, function (t) {
            t.preventDefault();if (a === "" || a === t.type) {
              var n = e(this),
                  s = r.controlNav.index(n);if (!n.hasClass(i + "active")) {
                s > r.currentSlide ? r.direction = "next" : r.direction = "prev";r.flexAnimate(s, r.vars.pauseOnAction);
              }
            }a === "" && (a = t.type);v.setToClearWatchedEvent();
          });
        }, set: function set() {
          var t = r.vars.controlNav === "thumbnails" ? "img" : "a";r.controlNav = e("." + i + "control-nav li " + t, r.controlsContainer ? r.controlsContainer : r);
        }, active: function active() {
          r.controlNav.removeClass(i + "active").eq(r.animatingTo).addClass(i + "active");
        }, update: function update(t, n) {
          r.pagingCount > 1 && t === "add" ? r.controlNavScaffold.append(e("<li><a>" + r.count + "</a></li>")) : r.pagingCount === 1 ? r.controlNavScaffold.find("li").remove() : r.controlNav.eq(n).closest("li").remove();v.controlNav.set();r.pagingCount > 1 && r.pagingCount !== r.controlNav.length ? r.update(n, t) : v.controlNav.active();
        } }, directionNav: { setup: function setup() {
          var t = e('<ul class="' + i + 'direction-nav"><li><a class="' + i + 'prev" href="#">' + r.vars.prevText + '</a></li><li><a class="' + i + 'next" href="#">' + r.vars.nextText + "</a></li></ul>");if (r.controlsContainer) {
            e(r.controlsContainer).append(t);r.directionNav = e("." + i + "direction-nav li a", r.controlsContainer);
          } else {
            r.append(t);r.directionNav = e("." + i + "direction-nav li a", r);
          }v.directionNav.update();r.directionNav.bind(u, function (t) {
            t.preventDefault();var n;if (a === "" || a === t.type) {
              n = e(this).hasClass(i + "next") ? r.getTarget("next") : r.getTarget("prev");r.flexAnimate(n, r.vars.pauseOnAction);
            }a === "" && (a = t.type);v.setToClearWatchedEvent();
          });
        }, update: function update() {
          var e = i + "disabled";r.pagingCount === 1 ? r.directionNav.addClass(e).attr("tabindex", "-1") : r.vars.animationLoop ? r.directionNav.removeClass(e).removeAttr("tabindex") : r.animatingTo === 0 ? r.directionNav.removeClass(e).filter("." + i + "prev").addClass(e).attr("tabindex", "-1") : r.animatingTo === r.last ? r.directionNav.removeClass(e).filter("." + i + "next").addClass(e).attr("tabindex", "-1") : r.directionNav.removeClass(e).removeAttr("tabindex");
        } }, pausePlay: { setup: function setup() {
          var t = e('<div class="' + i + 'pauseplay"><a></a></div>');if (r.controlsContainer) {
            r.controlsContainer.append(t);r.pausePlay = e("." + i + "pauseplay a", r.controlsContainer);
          } else {
            r.append(t);r.pausePlay = e("." + i + "pauseplay a", r);
          }v.pausePlay.update(r.vars.slideshow ? i + "pause" : i + "play");r.pausePlay.bind(u, function (t) {
            t.preventDefault();if (a === "" || a === t.type) if (e(this).hasClass(i + "pause")) {
              r.manualPause = !0;r.manualPlay = !1;r.pause();
            } else {
              r.manualPause = !1;r.manualPlay = !0;r.play();
            }a === "" && (a = t.type);v.setToClearWatchedEvent();
          });
        }, update: function update(e) {
          e === "play" ? r.pausePlay.removeClass(i + "pause").addClass(i + "play").html(r.vars.playText) : r.pausePlay.removeClass(i + "play").addClass(i + "pause").html(r.vars.pauseText);
        } }, touch: function touch() {
        var e,
            n,
            i,
            o,
            u,
            a,
            f = !1,
            d = 0,
            v = 0,
            m = 0;if (!s) {
          var g = function g(s) {
            if (r.animating) s.preventDefault();else if (window.navigator.msPointerEnabled || s.touches.length === 1) {
              r.pause();o = l ? r.h : r.w;a = Number(new Date());d = s.touches[0].pageX;v = s.touches[0].pageY;i = h && c && r.animatingTo === r.last ? 0 : h && c ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : h && r.currentSlide === r.last ? r.limit : h ? (r.itemW + r.vars.itemMargin) * r.move * r.currentSlide : c ? (r.last - r.currentSlide + r.cloneOffset) * o : (r.currentSlide + r.cloneOffset) * o;e = l ? v : d;n = l ? d : v;t.addEventListener("touchmove", y, !1);t.addEventListener("touchend", b, !1);
            }
          };

          var y = function y(t) {
            d = t.touches[0].pageX;v = t.touches[0].pageY;u = l ? e - v : e - d;f = l ? Math.abs(u) < Math.abs(d - n) : Math.abs(u) < Math.abs(v - n);var s = 500;if (!f || Number(new Date()) - a > s) {
              t.preventDefault();if (!p && r.transitions) {
                r.vars.animationLoop || (u /= r.currentSlide === 0 && u < 0 || r.currentSlide === r.last && u > 0 ? Math.abs(u) / o + 2 : 1);r.setProps(i + u, "setTouch");
              }
            }
          };

          var b = function b(s) {
            t.removeEventListener("touchmove", y, !1);if (r.animatingTo === r.currentSlide && !f && u !== null) {
              var l = c ? -u : u,
                  h = l > 0 ? r.getTarget("next") : r.getTarget("prev");r.canAdvance(h) && (Number(new Date()) - a < 550 && Math.abs(l) > 50 || Math.abs(l) > o / 2) ? r.flexAnimate(h, r.vars.pauseOnAction) : p || r.flexAnimate(r.currentSlide, r.vars.pauseOnAction, !0);
            }t.removeEventListener("touchend", b, !1);e = null;n = null;u = null;i = null;
          };

          t.addEventListener("touchstart", g, !1);
        } else {
          var w = function w(e) {
            e.stopPropagation();if (r.animating) e.preventDefault();else {
              r.pause();t._gesture.addPointer(e.pointerId);m = 0;o = l ? r.h : r.w;a = Number(new Date());i = h && c && r.animatingTo === r.last ? 0 : h && c ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : h && r.currentSlide === r.last ? r.limit : h ? (r.itemW + r.vars.itemMargin) * r.move * r.currentSlide : c ? (r.last - r.currentSlide + r.cloneOffset) * o : (r.currentSlide + r.cloneOffset) * o;
            }
          };

          var E = function E(e) {
            e.stopPropagation();var n = e.target._slider;if (!n) return;var r = -e.translationX,
                s = -e.translationY;m += l ? s : r;u = m;f = l ? Math.abs(m) < Math.abs(-r) : Math.abs(m) < Math.abs(-s);if (e.detail === e.MSGESTURE_FLAG_INERTIA) {
              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set_immediate___default()(function () {
                t._gesture.stop();
              });return;
            }if (!f || Number(new Date()) - a > 500) {
              e.preventDefault();if (!p && n.transitions) {
                n.vars.animationLoop || (u = m / (n.currentSlide === 0 && m < 0 || n.currentSlide === n.last && m > 0 ? Math.abs(m) / o + 2 : 1));n.setProps(i + u, "setTouch");
              }
            }
          };

          var S = function S(t) {
            t.stopPropagation();var r = t.target._slider;if (!r) return;if (r.animatingTo === r.currentSlide && !f && u !== null) {
              var s = c ? -u : u,
                  l = s > 0 ? r.getTarget("next") : r.getTarget("prev");r.canAdvance(l) && (Number(new Date()) - a < 550 && Math.abs(s) > 50 || Math.abs(s) > o / 2) ? r.flexAnimate(l, r.vars.pauseOnAction) : p || r.flexAnimate(r.currentSlide, r.vars.pauseOnAction, !0);
            }e = null;n = null;u = null;i = null;m = 0;
          };

          t.style.msTouchAction = "none";t._gesture = new MSGesture();t._gesture.target = t;t.addEventListener("MSPointerDown", w, !1);t._slider = r;t.addEventListener("MSGestureChange", E, !1);t.addEventListener("MSGestureEnd", S, !1);
        }
      }, resize: function resize() {
        if (!r.animating && r.is(":visible")) {
          h || r.doMath();if (p) v.smoothHeight();else if (h) {
            r.slides.width(r.computedW);r.update(r.pagingCount);r.setProps();
          } else if (l) {
            r.viewport.height(r.h);r.setProps(r.h, "setTotal");
          } else {
            r.vars.smoothHeight && v.smoothHeight();r.newSlides.width(r.computedW);r.setProps(r.computedW, "setTotal");
          }
        }
      }, smoothHeight: function smoothHeight(e) {
        if (!l || p) {
          var t = p ? r : r.viewport;e ? t.animate({ height: r.slides.eq(r.animatingTo).height() }, e) : t.height(r.slides.eq(r.animatingTo).height());
        }
      }, sync: function sync(t) {
        var n = e(r.vars.sync).data("flexslider"),
            i = r.animatingTo;switch (t) {case "animate":
            n.flexAnimate(i, r.vars.pauseOnAction, !1, !0);break;case "play":
            !n.playing && !n.asNav && n.play();break;case "pause":
            n.pause();}
      }, uniqueID: function uniqueID(t) {
        t.find("[id]").each(function () {
          var t = e(this);t.attr("id", t.attr("id") + "_clone");
        });return t;
      }, pauseInvisible: { visProp: null, init: function init() {
          var e = ["webkit", "moz", "ms", "o"];if ("hidden" in document) return "hidden";for (var t = 0; t < e.length; t++) {
            e[t] + "Hidden" in document && (v.pauseInvisible.visProp = e[t] + "Hidden");
          }if (v.pauseInvisible.visProp) {
            var n = v.pauseInvisible.visProp.replace(/[H|h]idden/, "") + "visibilitychange";document.addEventListener(n, function () {
              v.pauseInvisible.isHidden() ? r.startTimeout ? clearTimeout(r.startTimeout) : r.pause() : r.started ? r.play() : r.vars.initDelay > 0 ? setTimeout(r.play, r.vars.initDelay) : r.play();
            });
          }
        }, isHidden: function isHidden() {
          return document[v.pauseInvisible.visProp] || !1;
        } }, setToClearWatchedEvent: function setToClearWatchedEvent() {
        clearTimeout(f);f = setTimeout(function () {
          a = "";
        }, 3e3);
      } };r.flexAnimate = function (t, n, s, u, a) {
      !r.vars.animationLoop && t !== r.currentSlide && (r.direction = t > r.currentSlide ? "next" : "prev");d && r.pagingCount === 1 && (r.direction = r.currentItem < t ? "next" : "prev");if (!r.animating && (r.canAdvance(t, a) || s) && r.is(":visible")) {
        if (d && u) {
          var f = e(r.vars.asNavFor).data("flexslider");r.atEnd = t === 0 || t === r.count - 1;f.flexAnimate(t, !0, !1, !0, a);r.direction = r.currentItem < t ? "next" : "prev";f.direction = r.direction;if (Math.ceil((t + 1) / r.visible) - 1 === r.currentSlide || t === 0) {
            r.currentItem = t;r.slides.removeClass(i + "active-slide").eq(t).addClass(i + "active-slide");return !1;
          }r.currentItem = t;r.slides.removeClass(i + "active-slide").eq(t).addClass(i + "active-slide");t = Math.floor(t / r.visible);
        }r.animating = !0;r.animatingTo = t;n && r.pause();r.vars.before(r);r.syncExists && !a && v.sync("animate");r.vars.controlNav && v.controlNav.active();h || r.slides.removeClass(i + "active-slide").eq(t).addClass(i + "active-slide");r.atEnd = t === 0 || t === r.last;r.vars.directionNav && v.directionNav.update();if (t === r.last) {
          r.vars.end(r);r.vars.animationLoop || r.pause();
        }if (!p) {
          var m = l ? r.slides.filter(":first").height() : r.computedW,
              g,
              y,
              b;if (h) {
            g = r.vars.itemMargin;b = (r.itemW + g) * r.move * r.animatingTo;y = b > r.limit && r.visible !== 1 ? r.limit : b;
          } else r.currentSlide === 0 && t === r.count - 1 && r.vars.animationLoop && r.direction !== "next" ? y = c ? (r.count + r.cloneOffset) * m : 0 : r.currentSlide === r.last && t === 0 && r.vars.animationLoop && r.direction !== "prev" ? y = c ? 0 : (r.count + 1) * m : y = c ? (r.count - 1 - t + r.cloneOffset) * m : (t + r.cloneOffset) * m;r.setProps(y, "", r.vars.animationSpeed);if (r.transitions) {
            if (!r.vars.animationLoop || !r.atEnd) {
              r.animating = !1;r.currentSlide = r.animatingTo;
            }r.container.unbind("webkitTransitionEnd transitionend");r.container.bind("webkitTransitionEnd transitionend", function () {
              r.wrapup(m);
            });
          } else r.container.animate(r.args, r.vars.animationSpeed, r.vars.easing, function () {
            r.wrapup(m);
          });
        } else if (!o) {
          r.slides.eq(r.currentSlide).css({ zIndex: 1 }).animate({ opacity: 0 }, r.vars.animationSpeed, r.vars.easing);r.slides.eq(t).css({ zIndex: 2 }).animate({ opacity: 1 }, r.vars.animationSpeed, r.vars.easing, r.wrapup);
        } else {
          r.slides.eq(r.currentSlide).css({ opacity: 0, zIndex: 1 });r.slides.eq(t).css({ opacity: 1, zIndex: 2 });r.wrapup(m);
        }r.vars.smoothHeight && v.smoothHeight(r.vars.animationSpeed);
      }
    };r.wrapup = function (e) {
      !p && !h && (r.currentSlide === 0 && r.animatingTo === r.last && r.vars.animationLoop ? r.setProps(e, "jumpEnd") : r.currentSlide === r.last && r.animatingTo === 0 && r.vars.animationLoop && r.setProps(e, "jumpStart"));r.animating = !1;r.currentSlide = r.animatingTo;r.vars.after(r);
    };r.animateSlides = function () {
      !r.animating && m && r.flexAnimate(r.getTarget("next"));
    };r.pause = function () {
      clearInterval(r.animatedSlides);r.animatedSlides = null;r.playing = !1;r.vars.pausePlay && v.pausePlay.update("play");r.syncExists && v.sync("pause");
    };r.play = function () {
      r.playing && clearInterval(r.animatedSlides);r.animatedSlides = r.animatedSlides || setInterval(r.animateSlides, r.vars.slideshowSpeed);r.started = r.playing = !0;r.vars.pausePlay && v.pausePlay.update("pause");r.syncExists && v.sync("play");
    };r.stop = function () {
      r.pause();r.stopped = !0;
    };r.canAdvance = function (e, t) {
      var n = d ? r.pagingCount - 1 : r.last;return t ? !0 : d && r.currentItem === r.count - 1 && e === 0 && r.direction === "prev" ? !0 : d && r.currentItem === 0 && e === r.pagingCount - 1 && r.direction !== "next" ? !1 : e === r.currentSlide && !d ? !1 : r.vars.animationLoop ? !0 : r.atEnd && r.currentSlide === 0 && e === n && r.direction !== "next" ? !1 : r.atEnd && r.currentSlide === n && e === 0 && r.direction === "next" ? !1 : !0;
    };r.getTarget = function (e) {
      r.direction = e;return e === "next" ? r.currentSlide === r.last ? 0 : r.currentSlide + 1 : r.currentSlide === 0 ? r.last : r.currentSlide - 1;
    };r.setProps = function (e, t, n) {
      var i = function () {
        var n = e ? e : (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo,
            i = function () {
          if (h) return t === "setTouch" ? e : c && r.animatingTo === r.last ? 0 : c ? r.limit - (r.itemW + r.vars.itemMargin) * r.move * r.animatingTo : r.animatingTo === r.last ? r.limit : n;switch (t) {case "setTotal":
              return c ? (r.count - 1 - r.currentSlide + r.cloneOffset) * e : (r.currentSlide + r.cloneOffset) * e;case "setTouch":
              return c ? e : e;case "jumpEnd":
              return c ? e : r.count * e;case "jumpStart":
              return c ? r.count * e : e;default:
              return e;}
        }();return i * -1 + "px";
      }();if (r.transitions) {
        i = l ? "translate3d(0," + i + ",0)" : "translate3d(" + i + ",0,0)";n = n !== undefined ? n / 1e3 + "s" : "0s";r.container.css("-" + r.pfx + "-transition-duration", n);r.container.css("transition-duration", n);
      }r.args[r.prop] = i;(r.transitions || n === undefined) && r.container.css(r.args);r.container.css("transform", i);
    };r.setup = function (t) {
      if (!p) {
        var n, s;if (t === "init") {
          r.viewport = e('<div class="' + i + 'viewport"></div>').css({ overflow: "hidden", position: "relative" }).appendTo(r).append(r.container);r.cloneCount = 0;r.cloneOffset = 0;if (c) {
            s = e.makeArray(r.slides).reverse();r.slides = e(s);r.container.empty().append(r.slides);
          }
        }if (r.vars.animationLoop && !h) {
          r.cloneCount = 2;r.cloneOffset = 1;t !== "init" && r.container.find(".clone").remove();r.container.append(r.slides.first().clone().addClass("clone").attr("aria-hidden", "true")).prepend(r.slides.last().clone().addClass("clone").attr("aria-hidden", "true"));v.uniqueID(r.slides.first().clone().addClass("clone")).appendTo(r.container);v.uniqueID(r.slides.last().clone().addClass("clone")).prependTo(r.container);
        }r.newSlides = e(r.vars.selector, r);n = c ? r.count - 1 - r.currentSlide + r.cloneOffset : r.currentSlide + r.cloneOffset;if (l && !h) {
          r.container.height((r.count + r.cloneCount) * 200 + "%").css("position", "absolute").width("100%");setTimeout(function () {
            r.newSlides.css({ display: "block" });r.doMath();r.viewport.height(r.h);r.setProps(n * r.h, "init");
          }, t === "init" ? 100 : 0);
        } else {
          r.container.width((r.count + r.cloneCount) * 200 + "%");r.setProps(n * r.computedW, "init");setTimeout(function () {
            r.doMath();r.newSlides.css({ width: r.computedW, "float": "left", display: "block" });r.vars.smoothHeight && v.smoothHeight();
          }, t === "init" ? 100 : 0);
        }
      } else {
        r.slides.css({ width: "100%", "float": "left", marginRight: "-100%", position: "relative" });t === "init" && (o ? r.slides.css({ opacity: 0, display: "block", webkitTransition: "opacity " + r.vars.animationSpeed / 1e3 + "s ease", zIndex: 1 }).eq(r.currentSlide).css({ opacity: 1, zIndex: 2 }) : r.slides.css({ opacity: 0, display: "block", zIndex: 1 }).eq(r.currentSlide).css({ zIndex: 2 }).animate({ opacity: 1 }, r.vars.animationSpeed, r.vars.easing));r.vars.smoothHeight && v.smoothHeight();
      }h || r.slides.removeClass(i + "active-slide").eq(r.currentSlide).addClass(i + "active-slide");r.vars.init(r);
    };r.doMath = function () {
      var e = r.slides.first(),
          t = r.vars.itemMargin,
          n = r.vars.minItems,
          i = r.vars.maxItems;r.w = r.viewport === undefined ? r.width() : r.viewport.width();r.h = e.height();r.boxPadding = e.outerWidth() - e.width();if (h) {
        r.itemT = r.vars.itemWidth + t;r.minW = n ? n * r.itemT : r.w;r.maxW = i ? i * r.itemT - t : r.w;r.itemW = r.minW > r.w ? (r.w - t * (n - 1)) / n : r.maxW < r.w ? (r.w - t * (i - 1)) / i : r.vars.itemWidth > r.w ? r.w : r.vars.itemWidth;r.visible = Math.floor(r.w / r.itemW);r.move = r.vars.move > 0 && r.vars.move < r.visible ? r.vars.move : r.visible;r.pagingCount = Math.ceil((r.count - r.visible) / r.move + 1);r.last = r.pagingCount - 1;r.limit = r.pagingCount === 1 ? 0 : r.vars.itemWidth > r.w ? r.itemW * (r.count - 1) + t * (r.count - 1) : (r.itemW + t) * r.count - r.w - t;
      } else {
        r.itemW = r.w;r.pagingCount = r.count;r.last = r.count - 1;
      }r.computedW = r.itemW - r.boxPadding;
    };r.update = function (e, t) {
      r.doMath();if (!h) {
        e < r.currentSlide ? r.currentSlide += 1 : e <= r.currentSlide && e !== 0 && (r.currentSlide -= 1);r.animatingTo = r.currentSlide;
      }if (r.vars.controlNav && !r.manualControls) if (t === "add" && !h || r.pagingCount > r.controlNav.length) v.controlNav.update("add");else if (t === "remove" && !h || r.pagingCount < r.controlNav.length) {
        if (h && r.currentSlide > r.last) {
          r.currentSlide -= 1;r.animatingTo -= 1;
        }v.controlNav.update("remove", r.last);
      }r.vars.directionNav && v.directionNav.update();
    };r.addSlide = function (t, n) {
      var i = e(t);r.count += 1;r.last = r.count - 1;l && c ? n !== undefined ? r.slides.eq(r.count - n).after(i) : r.container.prepend(i) : n !== undefined ? r.slides.eq(n).before(i) : r.container.append(i);r.update(n, "add");r.slides = e(r.vars.selector + ":not(.clone)", r);r.setup();r.vars.added(r);
    };r.removeSlide = function (t) {
      var n = isNaN(t) ? r.slides.index(e(t)) : t;r.count -= 1;r.last = r.count - 1;isNaN(t) ? e(t, r.slides).remove() : l && c ? r.slides.eq(r.last).remove() : r.slides.eq(t).remove();r.doMath();r.update(n, "remove");r.slides = e(r.vars.selector + ":not(.clone)", r);r.setup();r.vars.removed(r);
    };v.init();
  };e(window).blur(function (e) {
    focused = !1;
  }).focus(function (e) {
    focused = !0;
  });e.flexslider.defaults = { namespace: "flex-", selector: ".slides > li", animation: "fade", easing: "swing", direction: "horizontal", reverse: !1, animationLoop: !0, smoothHeight: !1, startAt: 0, slideshow: !0, slideshowSpeed: 7e3, animationSpeed: 600, initDelay: 0, randomize: !1, thumbCaptions: !1, pauseOnAction: !0, pauseOnHover: !1, pauseInvisible: !0, useCSS: !0, touch: !0, video: !1, controlNav: !0, directionNav: !0, prevText: "Previous", nextText: "Next", keyboard: !0, multipleKeyboard: !1, mousewheel: !1, pausePlay: !1, pauseText: "Pause", playText: "Play", controlsContainer: "", manualControls: "", sync: "", asNavFor: "", itemWidth: 0, itemMargin: 0, minItems: 1, maxItems: 0, move: 0, allowOneSlide: !0, start: function start() {}, before: function before() {}, after: function after() {}, end: function end() {}, added: function added() {}, removed: function removed() {}, init: function init() {} };e.fn.flexslider = function (t) {
    t === undefined && (t = {});if ((typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(t)) == "object") return this.each(function () {
      var n = e(this),
          r = t.selector ? t.selector : ".slides > li",
          i = n.find(r);if (i.length === 1 && t.allowOneSlide === !0 || i.length === 0) {
        i.fadeIn(400);t.start && t.start(n);
      } else n.data("flexslider") === undefined && new e.flexslider(this, t);
    });var n = e(this).data("flexslider");switch (t) {case "play":
        n.play();break;case "pause":
        n.pause();break;case "stop":
        n.stop();break;case "next":
        n.flexAnimate(n.getTarget("next"), !0);break;case "prev":case "previous":
        n.flexAnimate(n.getTarget("prev"), !0);break;default:
        typeof t == "number" && n.flexAnimate(t, !0);}
  };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__langs_tc_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__langs_zh_js__ = __webpack_require__(142);


// 注册VueI18n

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
// 引入VueI18n


/**
 * 格式化 window.location.pathname
 * @param {*} pathUrl
 */
function resolvePathName(pathUrl) {
    // browsers replaceAll 存在限制
    // return (pathUrl + '').replaceAll(''"', '')
    return (pathUrl + '').replace(/\//g, '');
}
console.log(window.location);
var locale = '';
if (['www.tintinhealth.cn', 'tintinhealth.cn'].includes(resolvePathName(location.hostname))) {
    document.title = __WEBPACK_IMPORTED_MODULE_3__langs_zh_js__["a" /* default */].common.company;
    locale = 'zh';
}
if (['www.tintintechnology.cn', 'tintintechnology.cn'].includes(resolvePathName(location.hostname))) {
    document.title = __WEBPACK_IMPORTED_MODULE_2__langs_tc_js__["a" /* default */].common.company;
    locale = 'tc';
}
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    // locale: localStorage.getItem('languageStorage') || 'zh',
    locale: locale || 'zh',
    messages: {
        zh: __WEBPACK_IMPORTED_MODULE_3__langs_zh_js__["a" /* default */],
        tc: __WEBPACK_IMPORTED_MODULE_2__langs_tc_js__["a" /* default */]
    }
});
/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_HomePanel__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_HomePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_HomePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Service__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_About__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Contact__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Service_scommunity__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Service_scommunity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Service_scommunity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Service_shealth__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Service_shealth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Service_shealth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Service_smec__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Service_smec___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Service_smec__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Service_sservice__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Service_sservice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Service_sservice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_About_aprofile__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_About_aprofile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_About_aprofile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_About_aqualification__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_About_aqualification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_About_aqualification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Contact_league_cooperation__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Contact_league_cooperation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Contact_league_cooperation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Contact_recruitment__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Contact_recruitment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Contact_recruitment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_reset_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_css_style_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_css_style_css__);
























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    // base: "wesite",
    // mode: "history",
    routes: [{
        path: "/",
        component: __WEBPACK_IMPORTED_MODULE_2__views_HomePanel___default.a,
        children: [{ path: "/", redirect: "/home", component: __WEBPACK_IMPORTED_MODULE_3__views_Home___default.a }, { path: "/home", component: __WEBPACK_IMPORTED_MODULE_3__views_Home___default.a }, {
            path: "/service",
            component: __WEBPACK_IMPORTED_MODULE_4__views_Service___default.a,
            children: [{ path: "/service/", redirect: "/service/sservice", component: __WEBPACK_IMPORTED_MODULE_10__components_Service_sservice___default.a }, { path: "/service/sservice", component: __WEBPACK_IMPORTED_MODULE_10__components_Service_sservice___default.a }, { path: "/service/smec", component: __WEBPACK_IMPORTED_MODULE_9__components_Service_smec___default.a }, { path: "/service/shealth", component: __WEBPACK_IMPORTED_MODULE_8__components_Service_shealth___default.a }, { path: "/service/scommunity", component: __WEBPACK_IMPORTED_MODULE_7__components_Service_scommunity___default.a }]
        }, {
            path: "/about",
            component: __WEBPACK_IMPORTED_MODULE_5__views_About___default.a,
            children: [{ path: "/about/", redirect: "/about/aprofile", component: __WEBPACK_IMPORTED_MODULE_11__components_About_aprofile___default.a }, { path: "/about/aprofile", component: __WEBPACK_IMPORTED_MODULE_12__components_About_aqualification___default.a }, { path: "/about/aqualification", component: __WEBPACK_IMPORTED_MODULE_11__components_About_aprofile___default.a }]
        }, {
            path: "/contact",
            component: __WEBPACK_IMPORTED_MODULE_6__views_Contact___default.a,
            children: [{ path: "/contact/", redirect: "/contact/league_cooperation", component: __WEBPACK_IMPORTED_MODULE_13__components_Contact_league_cooperation___default.a }, { path: "/contact/league_cooperation", component: __WEBPACK_IMPORTED_MODULE_13__components_Contact_league_cooperation___default.a }, { path: "/contact/recruitment", component: __WEBPACK_IMPORTED_MODULE_14__components_Contact_recruitment___default.a }]
        }]
    }]
}));

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(264),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            // txt1:'丁丁云康信息科技有限公司成立2016年，是一家专注于健康管理信息服务的高新技术企业。公司主要从事健康促进管理领域的信息技术研发，跨界整合云架构移动互联网技术和健康管理专业资源，以智能健康管理大数据平台为核心，借助移动互联网、IOT技术实现端到端的解决方案，协助各类机构、企业的健康管理部门延伸服务范围、完善服务质量、提升服务效率，同时帮助个人用户实现日常的健康自我管理与数据跟踪踪、分析。“丁丁云康”愿通过自己的努力成为每个人的贴身健康管家，使健康自我管理与促进成为大家每日生活中随时、随地可以轻松实现的工作，不再复杂、繁重。',
            // txt2:'公司团队由资深信息技术专家和经验丰富的健康顾问组成，丁丁云康健康管理平台成功地为医疗机构、体检机构、社康中心、健管中心等单位提供健康管理的信息技术服务与支持。丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。',
            // txt3:'丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。'

            txt1: '广东省健康医疗大数据产业园入驻企业',
            txt2: '广东省医学大数据融合应用工程中心合作伙伴'
        };
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            txt1: '丁丁云康信息科技有限公司成立2016年，是一家专注于健康管理信息服务的高新技术企业。公司主要从事健康促进管理领域的信息技术研发，跨界整合云架构移动互联网技术和健康管理专业资源，以智能健康管理大数据平台为核心，借助移动互联网、IOT技术实现端到端的解决方案，协助各类机构、企业的健康管理部门延伸服务范围、完善服务质量、提升服务效率，同时帮助个人用户实现日常的健康自我管理与数据跟踪踪、分析。“丁丁云康”愿通过自己的努力成为每个人的贴身健康管家，使健康自我管理与促进成为大家每日生活中随时、随地可以轻松实现的工作，不再复杂、繁重。',
            txt2: '公司团队由资深信息技术专家和经验丰富的健康顾问组成，丁丁云康健康管理平台成功地为医疗机构、体检机构、社康中心、健管中心等单位提供健康管理的信息技术服务与支持。丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。',
            txt3: '丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。'
        };
    }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            txt1: 'tab4_text',
            imgUrl: __webpack_require__(239)
        };
    }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            txt1: 'tab3_text',
            imgUrl: __webpack_require__(238)
        };
    }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            txt1: 'tab2_text',
            imgUrl: __webpack_require__(237)
        };
    }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            txts: [
            // {title:'一个平台',text:'开放的、大数据平台'},
            // {title:'四大系统',text:'健康检测系统,健康评估系统,档案管理系统,健康促进系统'},
            // {title:'五种服务',text:'体检服务,社区健康服务,用户健康档案管理服务,用户健康、慢病评估服务,个人健康促进管理服务'}
            { title: 'tab1_1', route: '/Service/product_list1', from: 'product_list1', flag: 'product_list1' }, { title: 'tab1_2', route: '/Service/product_list2', from: 'sservice' }, { title: 'tab1_3', route: '/Service/product_list3', from: 'sservice' }, { title: 'tab1_4', route: '/Service/product_list4', from: 'sservice' }, { title: 'tab1_5', route: '/Service/product_list5', from: 'sservice' }, { title: 'tab1_6', route: '/Service/product_list6', from: 'sservice' }, { title: 'tab1_7', route: '/Service/product_list7', from: 'sservice' }, { title: 'tab1_8', route: '/Service/product_list8', from: 'sservice' }, { title: 'tab1_9', route: '/Service/product_list9', from: 'sservice' }, { title: 'tab1_10', route: '/Service/product_list10', from: 'sservice' }, { title: 'tab1_11', route: '/Service/product_list11', from: 'sservice' }],
            imgUrl: __webpack_require__(240)
        };
    }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'footer',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            modules: [{ name: 'home', to: '/Home' }, { name: 'service', to: '/Service' }, { name: 'about', to: '/About' }, { name: 'contact', to: '/Contact' }],
            activeTo: '/Home',
            varLang: 'zh'
        };
    },
    mounted: function mounted() {
        this.varLang = localStorage.getItem('languageStorage') || 'zh';
    },

    methods: {
        selected: function selected(to) {
            $('.fontColor>li').eq(2).removeClass('activeUnderline');
            if (typeof to != 'string') return;
            this.activeTo = to;
            // console.log(this.varLang)
            // if(to == '/Home'){window.location.reload()};
            // console.log(this.activeTo);
        },
        langChange: function langChange(lang) {
            console.log(lang);
            localStorage.setItem('languageStorage', lang);
            location.reload();
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      aboutTab: 'tab1',
      sonModules: [{ name: 'tab1', to: '/About/aqualification' }, { name: 'tab2', to: '/About/aprofile' }],
      activeToSon: '/About/aprofile'
    };
  },

  methods: {
    selected: function selected(sonModule) {
      if ((typeof sonModule === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sonModule)) != 'object') return;
      this.activeToSon = sonModule.to;
      this.aboutTab = sonModule.name;
    }
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      jionTab: 'tab1',
      sonModules: [{ name: 'tab1', to: '/Contact/league_cooperation' }, { name: 'tab2', to: '/Contact/recruitment' }],
      activeToSon: '/Contact/league_cooperation'
    };
  },

  methods: {
    selected: function selected(sonModule) {
      if ((typeof sonModule === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sonModule)) != 'object') return;
      this.activeToSon = sonModule.to;
      this.jionTab = sonModule.name;
    }
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'home',
    data: function data() {
        return {
            locationUrl: ''
        };
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            $(".flexslider").flexslider({
                slideshowSpeed: 4000, //展示时间间隔ms
                animationSpeed: 400, //滚动时间ms
                touch: true //是否支持触屏滑动
            });
        });
    },

    methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Header__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Footer__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Footer__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {};
    },

    components: {
        'v-header': __WEBPACK_IMPORTED_MODULE_0__components_common_Header___default.a,
        'v-footer': __WEBPACK_IMPORTED_MODULE_1__components_common_Footer___default.a
    }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            prodectTab: 'tab1',
            sonModules: [{ name: 'tab1', to: '/Service/sservice' }, { name: 'tab2', to: '/Service/smec' }, { name: 'tab3', to: '/Service/shealth' }, { name: 'tab4', to: '/Service/scommunity' }],
            activeToSon: '/Service/sservice'
        };
    },

    methods: {
        selected: function selected(sonModule) {
            if ((typeof sonModule === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sonModule)) != 'object') return;
            this.activeToSon = sonModule.to;
            this.prodectTab = sonModule.name;
        }
    }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var langs = {
    language: {
        name: '繁体中文'
    },
    common: {
        more: "更多>>",
        company: "澳门丁丁投资官网"
    },
    header: {
        home: '首頁',
        service: '產品服務',
        about: '關於我們',
        contact: '聯系我們',
        others: '企業門戶',
        other_option1: '醫生門戶',
        other_option2: '運營門戶'
    },
    footer: {
        tel_label: "聯系電話",
        tel_val: "853-28821988",
        email_label: "企業郵箱",
        company_address_label: "公司地址",
        company_address: "澳門新口岸馬濟時總督大馬路13號雙鑽第二棟11樓M",
        copyright: "版本所有@2022 丁丁健康投資發展有限公司",
        case_number: "備案號:粵ICP備2021001423號-1"
    },
    home: {
        company_profile: "澳門丁丁健康投資發展有限公司是壹家專註於大健康領域投資的領先企業，多年來壹直在國內布局線下創辦醫療機構和提供線上互聯網醫療服務業務。公司線上互聯網醫療板塊主要從事健康促進管理領域的信息技術研發，跨界整合雲架構移動互聯網技術和健康管理專業資源，以智能健康管理大數據平臺為核心，借助移動互聯網、IOT技術實現端到端的解決方案，協助各類機構、企業的健康管理部門延伸服務範圍、完善服務質量、提升服務效率，同時幫助個人用戶實現日常的健康自我管理與數據跟蹤蹤、分析。丁丁健康願努力成為每個人的貼身健康管家，使健康自我管理與健康促進成為大家每日生活中必需品。丁丁健康數字健康管理平臺成功地為醫療機構、體檢機構、社康中心、健管中心等單位提供健康管理的信息技術服務與支持。丁丁健康堅持技術持續創新、服務以人為本、不斷為客戶創造價值的發展理念，希望借助人工智能、大數據及移動互聯網的發展使更多的用戶可以關註自身健康、更容易地實現自我健康管理與促進、更好地享受健康生活。",
        health_intervention: "健康幹預",
        health_intervention_desc: "通過無縫、高效的健康幹預服務，丁丁健康可以幫助客戶隨時隨地掌握自己的健康狀況、促進目標。了解健康促進計劃與效果，從而有計劃、有步驟地以多種形式改善個人的生活方式和習慣，實現個人健康管理計劃的目標。",
        partner_organization: "合作機構"
    },
    service: {
        tab1: '產品服務',
        tab2: '體檢中心',
        tab3: '健康服務',
        tab4: '社區服務',
        tab1_1: "丁丁健康智能體檢系統V3.0",
        tab1_2: "丁丁健康智能排隊系統V3.0",
        tab1_3: "丁丁健康智能LIS系統V3.0",
        tab1_4: "丁丁健康智能PACS系統V3.0",
        tab1_5: "丁丁健康智能OA系統V3.0",
        tab1_6: "丁丁健康智能健康管理系統V3.0",
        tab1_7: "丁丁健康智能回訪系統V3.0",
        tab1_8: "丁丁健康中醫體質辨識軟件V3.0",
        tab1_9: "丁丁健康婦幼保健系統V5.0",
        tab1_10: "丁丁健康職業病體檢系統V5.0",
        tab1_11: "丁丁健康APP",
        tab2_text: "強大的體檢中心管理系統，全數字化管理軟件，實現完備的體檢業務流程，為體檢中心的業務擴展提供有力的技術支撐。",
        tab3_text: "面向用戶的健康管理服務，通過逐步改善個人的生活方式和習慣，提升個人健康水平、遠離疾病。",
        tab4_text: "完善的產品體系，助力社區開展基層健康管理與用戶跟蹤服務。"
    },
    contact: {
        tab1: '加盟合作',
        tab2: '招聘精英',
        tab1_address_label_1: '廣州公司地址:',
        tab1_address_1: '廣東省廣州市黃浦區至泰廣場A4棟606',
        tab1_address_label_2: '聯系電話:',
        tab1_address_2: '',
        tab1_address_label_3: '北京公司地址:',
        tab1_address_3: '北京市密雲區康馨雅苑38號樓3單元101',
        tab1_address_label_4: '聯系電話:',
        tab1_address_4: '',
        tab1_address_label_5: '佛山公司地址:',
        tab1_address_5: '佛山順德南德醫科大學醫療大數據產業園首層110室',
        tab1_address_label_6: '聯系電話:',
        tab1_address_6: '',
        tab1_address_label_7: '重慶公司地址:',
        tab1_address_7: '重慶市九龍坡區奧體運動街150號21-4房',
        tab1_address_label_8: '联系电话:',
        tab1_address_8: '',
        tab2_address_label_1: '聯系電話:',
        tab2_address_1: '',
        tab2_address_label_2: '企業郵箱:',
        tab2_address_2: '',
        tab2_address_label_3: '公司地址:',
        tab2_address_3: '廣東省廣州市黃浦區至泰廣場A4棟606'

    },
    about: {
        tab1: '公司概況',
        tab2: '公司資質',
        company_intro_1: "澳門丁丁健康投資發展有限公司是壹家專註於大健康領域投資的領先企業，多年來壹直在國內布局線下創辦醫療機構和提供線上互聯網醫療服務業務。公司線上互聯網醫療板塊主要從事健康促進管理領域的信息技術研發，跨界整合雲架構移動互聯網技術和健康管理專業資源，以智能健康管理大數據平臺為核心，借助移動互聯網、IOT技術實現端到端的解決方案，協助各類機構、企業的健康管理部門延伸服務範圍、完善服務質量、提升服務效率，同時幫助個人用戶實現日常的健康自我管理與數據跟蹤蹤、分析。丁丁健康願努力成為每個人的貼身健康管家，使健康自我管理與健康促進成為大家每日生活中必需品。丁丁健康數字健康管理平臺成功地為醫療機構、體檢機構、社康中心、健管中心等單位提供健康管理的信息技術服務與支持。丁丁健康堅持技術持續創新、服務以人為本、不斷為客戶創造價值的發展理念，希望借助人工智能、大數據及移動互聯網的發展使更多的用戶可以關註自身健康、更容易地實現自我健康管理與促進、更好地享受健康生活。",
        company_intro_2: "公司團隊由資深信息技術專家和經驗豐富的健康顧問組成，丁丁健康健康管理平臺成功地為醫療機構、體檢機構、社康中心、健管中心等單位提供健康管理的信息技術服務與支持。丁丁健康堅持技術持續創新、服務以人為本、不斷為客戶創造價值的發展理念，希望借助人工智能、大數據及移動互聯網的發展使更多的用戶可以關註自身健康、更容易地實現自我健康管理與促進、更好地享受健康生活。",
        company_intro_3: "丁丁健康堅持技術持續創新、服務以人為本、不斷為客戶創造價值的發展理念，希望借助人工智能、大數據及移動互聯網的發展使更多的用戶可以關註自身健康、更容易地實現自我健康管理與促進、更好地享受健康生活。",
        company_qualification_1: "廣東省健康醫療大數據產業園入駐企業",
        company_qualification_2: "廣東省醫學大數據融合應用工程中心合作夥伴"
    }
};
/* harmony default export */ __webpack_exports__["a"] = (langs);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var langs = {
    language: {
        name: '简体中文'
    },
    common: {
        more: "更多>>",
        company: "丁丁健康官方网站"
    },
    header: {
        home: '首页',
        service: '产品服务',
        about: '关于我们',
        contact: '联系我们',
        others: '企业门户',
        other_option1: '医生门户',
        other_option2: '运营门户'
    },
    footer: {
        tel_label: "联系电话",
        tel_val: "400-668-1008",
        email_label: "企业邮箱",
        company_address_label: "公司地址",
        company_address: "广东省广州市黄浦区至泰广场A4栋606室",
        copyright: "版本所有@2022 广州丁丁云康科技有限公司",
        case_number: "备案号:粤ICP备2022046615号-1"
    },
    home: {
        company_profile: "丁丁云康信息科技有限公司成立2016年，是一家专注于健康管理信息服务的高新技术企业。公司主要从事健康促进管理领域的信息技术研发，跨界整合云架构移动互联网技术和健康管理专业资源，以智能健康管理大数据平台为核心，借助移动互联网、IOT技术实现端到端的解决方案，协助各类机构、企业的健康管理部门延伸服务范围、完善服务质量、提升服务效率，同时帮助个人用户实现日常的健康自我管理与数据跟踪踪、分析......",
        health_intervention: "健康干预",
        health_intervention_desc: "通过无缝、高效的健康干预服务，丁丁云康可以帮助客户随时随地掌握自己的健康状况、促进目标。了解健康促进计划与效果，从而有计划、有步骤地以多种形式改善个人的生活方式和习惯，实现个人健康管理计划的目标。",
        partner_organization: "合作机构"
    },
    service: {
        tab1: '产品服务',
        tab2: '体检中心',
        tab3: '健康服务',
        tab4: '社区服务',
        tab1_1: "丁丁健康智能体检系统V3.0",
        tab1_2: "丁丁健康智能排队系统V3.0",
        tab1_3: "丁丁健康智能LIS系统V3.0",
        tab1_4: "丁丁健康智能PACS系统V3.0",
        tab1_5: "丁丁健康智能OA系统V3.0",
        tab1_6: "丁丁健康智能健康管理系统V3.0",
        tab1_7: "丁丁健康智能回访系统V3.0",
        tab1_8: "丁丁健康中医体质辨识软件V3.0",
        tab1_9: "丁丁健康妇幼保健系统V5.0",
        tab1_10: "丁丁健康职业病体检系统V5.0",
        tab1_11: "丁丁健康APP",
        tab2_text: "强大的体检中心管理系统，全数字化管理软件，实现完备的体检业务流程，为体检中心的业务扩展提供有力的技术支撑。",
        tab3_text: "面向用户的健康管理服务，通过逐步改善个人的生活方式和习惯，提升个人健康水平、远离疾病。",
        tab4_text: "完善的产品体系，助力社区开展基层健康管理与用户跟踪服务。"
    },
    contact: {
        tab1: '加盟合作',
        tab2: '招聘精英',
        tab1_address_label_1: '广州公司地址:',
        tab1_address_1: '广东省广州市黄浦区至泰广场A4栋606',
        tab1_address_label_2: '联系电话:',
        tab1_address_2: '',
        tab1_address_label_3: '北京公司地址:',
        tab1_address_3: '北京市密云区康馨雅苑38号楼3单元101',
        tab1_address_label_4: '联系电话:',
        tab1_address_4: '',
        tab1_address_label_5: '佛山公司地址:',
        tab1_address_5: '佛山顺德南德医科大学医疗大数据产业园首层110室',
        tab1_address_label_6: '联系电话:',
        tab1_address_6: '',
        tab1_address_label_7: '重庆公司地址:',
        tab1_address_7: '重庆市九龙坡区奥体运动街150号21-4房',
        tab1_address_label_8: '联系电话:',
        tab1_address_8: '',
        tab2_address_label_1: '联系电话:',
        tab2_address_1: '',
        tab2_address_label_2: '企业邮箱:',
        tab2_address_2: '',
        tab2_address_label_3: '公司地址:',
        tab2_address_3: '广东省广州市黄浦区至泰广场A4栋606'

    },
    about: {
        tab1: '公司概况',
        tab2: '公司资质',
        company_intro_1: "丁丁云康信息科技有限公司成立2016年，是一家专注于健康管理信息服务的高新技术企业。公司主要从事健康促进管理领域的信息技术研发，跨界整合云架构移动互联网技术和健康管理专业资源，以智能健康管理大数据平台为核心，借助移动互联网、IOT技术实现端到端的解决方案，协助各类机构、企业的健康管理部门延伸服务范围、完善服务质量、提升服务效率，同时帮助个人用户实现日常的健康自我管理与数据跟踪踪、分析。“丁丁云康”愿通过自己的努力成为每个人的贴身健康管家，使健康自我管理与促进成为大家每日生活中随时、随地可以轻松实现的工作，不再复杂、繁重。",
        company_intro_2: "公司团队由资深信息技术专家和经验丰富的健康顾问组成，丁丁云康健康管理平台成功地为医疗机构、体检机构、社康中心、健管中心等单位提供健康管理的信息技术服务与支持。丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。",
        company_intro_3: "丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。",
        company_qualification_1: "广东省健康医疗大数据产业园入驻企业",
        company_qualification_2: "广东省医学大数据融合应用工程中心合作伙伴"
    }
};
/* harmony default export */ __webpack_exports__["a"] = (langs);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_assets_css_reset_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_assets_css_flexslider_css__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_assets_css_flexslider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_assets_css_flexslider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_assets_js_jquery_flexslider_min_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_assets_css_bootstrap_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_assets_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__src_assets_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_assets_js_bootstrap_min_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_assets_css_style_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_assets_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__src_assets_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_i18n__ = __webpack_require__(120);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jquery___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_10__i18n_i18n__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.83dc2dc.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.9a2277c.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.29affb8.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.ff37dcd.jpg";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/a.19e18ce.jpg";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/b.67b4df5.jpg";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/c.bb42c71.jpg";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pro_cp.3be68ec.png";

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/web3-20.fd49b44.png";

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 246 */,
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(263),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07ef5126",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(265),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f171aa8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(266),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f1a9b76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(267),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43ce1ba1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(277),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa9123a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(275),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-efed32ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(274),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b33b4164",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(272),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ac7cdb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(270),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6369f3f3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(276),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6c75036",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(269),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d2d51cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(273),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8cc6233c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(271),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7205aee6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(262),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00f235a7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(268),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-443c3e77",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-header'), _vm._v(" "), _c('div', {
    staticClass: "a-main"
  }, [_c('router-view')], 1), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.$t("about.tab1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.company_intro_1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.company_intro_2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.company_intro_3")))])])
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v("公司资质")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.company_qualification_1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.company_qualification_2")))])])
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "contents-jion"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v("加盟合作")]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_label_1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_1")))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_label_2")))]), _vm._v(" "), _c('p', [_vm._v("18601311912")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_label_3")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_3")))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_label_4")))]), _vm._v(" "), _c('p', [_vm._v("010-56431371/18601311912")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_label_5")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_5")))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_label_6")))]), _vm._v(" "), _c('p', [_vm._v("19902344858")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_label_7")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_7")))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab1_address_label_1")))]), _vm._v(" "), _c('p', [_vm._v("13389657597")])])])
},staticRenderFns: []}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "contents-jion"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v("招聘精英")]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab2_address_label_1")))]), _vm._v(" "), _c('p', [_vm._v("18601311912")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab2_address_label_2")))]), _vm._v(" "), _c('p', [_vm._v("hr@tintinhealth.com")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab2_address_label_3")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("contact.tab2_address_3")))])])])
},staticRenderFns: []}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-infos-containter_2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-offset-1 col-lg-10 all-infos-wrap"
  }, [_c('div', {
    staticClass: "all-infos-wrap-d"
  }, [_c('ol', {
    staticClass: "navbar-wrap row"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sonModules), function(sonModule, index) {
    return _c('li', {
      key: index,
      staticClass: "col-md-2 col-sm-2 col-xs-3",
      class: {
        activedecoration: _vm.activeToSon == sonModule.to
      },
      on: {
        "click": function($event) {
          return _vm.selected(sonModule)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": sonModule.to
      }
    }, [_vm._v(_vm._s(_vm.$t(("service." + (sonModule.name)))))])], 1)
  })], 2), _vm._v(" "), _c('h5', {
    staticClass: "title-url-address"
  }, [_c('span', [_vm._v("当前位置:")]), _vm._v(" "), _c('a', {
    staticClass: "narmal-select"
  }, [_vm._v(_vm._s(_vm.$t("header.home")) + ">")]), _vm._v(" "), _c('a', {
    staticClass: "narmal-select"
  }, [_vm._v(_vm._s(_vm.$t("header.about")) + ">")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t(("service." + _vm.prodectTab)))
    }
  })]), _vm._v(" "), _c('router-view')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-2 col-sm-2 col-xs-10"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(241),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-infos-containter_5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-offset-1 col-lg-10 all-infos-wrap"
  }, [_c('div', {
    staticClass: "all-infos-wrap-d"
  }, [_c('ol', {
    staticClass: "navbar-wrap row"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sonModules), function(sonModule, index) {
    return _c('li', {
      key: index,
      staticClass: "col-md-2 col-sm-2 col-xs-6",
      class: {
        activedecoration: _vm.activeToSon == sonModule.to
      },
      on: {
        "click": function($event) {
          return _vm.selected(sonModule)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": sonModule.to
      }
    }, [_vm._v(_vm._s(_vm.$t(("about." + (sonModule.name)))))])], 1)
  })], 2), _vm._v(" "), _c('h5', {
    staticClass: "title-url-address"
  }, [_c('span', [_vm._v("当前位置:")]), _vm._v(" "), _c('a', {
    staticClass: "narmal-select"
  }, [_vm._v(_vm._s(_vm.$t("header.home")) + ">")]), _vm._v(" "), _c('a', {
    staticClass: "narmal-select"
  }, [_vm._v(_vm._s(_vm.$t("header.about")) + ">")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t(("about." + _vm.aboutTab)))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contents-box"
  }, [_c('router-view')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-2 col-sm-2 col-xs-8"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(242),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-6 col-md-offset-0 col-sm-offset-0 col-xs-offset-1 footer-contents"
  }, [_c('ol', {
    staticClass: "address-infos"
  }, [_c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-4 col-sm-5 col-xs-4"
  }, [_vm._v(_vm._s(_vm.$t("footer.tel_label")))]), _vm._v(" "), _c('p', {
    staticClass: "col-md-8 col-sm-7 col-xs-8"
  }, [_vm._v(_vm._s(_vm.$t("footer.tel_val")))])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-4 col-sm-5 col-xs-4"
  }, [_vm._v(_vm._s(_vm.$t("footer.email_label")))]), _vm._v(" "), _c('p', {
    staticClass: "col-md-8 col-sm-7 col-xs-8"
  }, [_vm._v("devops@tintinhealth.com")])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-4 col-sm-5 col-xs-4"
  }, [_vm._v(_vm._s(_vm.$t("footer.company_address_label")))]), _vm._v(" "), _c('p', {
    staticClass: "col-md-8 col-sm-7 col-xs-8"
  }, [_vm._v(_vm._s(_vm.$t("footer.company_address")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-6 col-xs-12 col-md-offset-1 col-sm-offset-0"
  }, [_c('ol', {
    staticClass: "row qr-code-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("footer.copyright")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("footer.case_number")))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-4 footer-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "codeImg col-md-3 col-sm-3 col-xs-3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(245),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container home-content-box"
  }, [_c('div', {
    staticClass: "col-lg-offset-1 col-lg-10"
  }, [_c('ol', {
    staticClass: "row",
    attrs: {
      "id": "company-infos"
    }
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "col-md-7 col-sm-7 col-xs-12 company-txt"
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$t("home.company_profile")) + "\n          ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("common.more")))])])]), _vm._v(" "), _c('div', {
    staticClass: "cutting-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "health-help"
  }, [_c('h4', {
    staticClass: "title-md"
  }, [_c('a', {
    attrs: {
      "href": "###"
    }
  }, [_vm._v(_vm._s(_vm.$t("home.health_intervention"))), _c('em', [_vm._v("Health Intervention")])])]), _vm._v(" "), _c('ol', {
    staticClass: "row health-help-ol"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "col-md-6 col-sm-6 col-xs-12"
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$t("home.health_intervention_desc")) + "\n          ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "###"
    }
  }, [_vm._v(_vm._s(_vm.$t("common.more")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "cutting-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "company-partner"
  }, [_c('h4', {
    staticClass: "title-md"
  }, [_c('a', {
    attrs: {
      "href": "###"
    }
  }, [_vm._v(_vm._s(_vm.$t("home.partner_organization"))), _c('em', [_vm._v("Partner Organization")])])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-container"
  }, [_c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "flexslider banner-box"
  }, [_c('ul', {
    staticClass: "slides"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(235)
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(244)
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-offset-0 col-sm-offset-0 col-md-4 col-sm-4 col-xs-offset-2 col-xs-8 company-sign"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(236),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-4 col-sm-4 col-md-offset-0 col-sm-offset-0 col-xs-8 col-xs-offset-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(233),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "row partner-lists"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(234),
      "alt": ""
    }
  })])])
}]}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contents-box row"
  }, [_c('div', {
    staticClass: "contents-lists"
  }, _vm._l((_vm.txts), function(txt, index) {
    return _c('div', {
      key: index,
      staticClass: "contents-list"
    }, [_c('h3', {
      staticClass: "title-text"
    }, [_vm._v(_vm._s(_vm.$t(("service." + (txt.title)))))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(txt.text))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-infos-containter_6"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-1 all-infos-wrap"
  }, [_c('div', {
    staticClass: "all-infos-wrap-d"
  }, [_c('ol', {
    staticClass: "navbar-wrap row"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sonModules), function(sonModule, index) {
    return _c('li', {
      key: index,
      staticClass: "col-md-2 col-sm-2 col-xs-6",
      class: {
        activedecoration: _vm.activeToSon == sonModule.to
      },
      on: {
        "click": function($event) {
          return _vm.selected(sonModule)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": sonModule.to
      }
    }, [_vm._v(_vm._s(_vm.$t(("contact." + (sonModule.name)))))])], 1)
  })], 2), _vm._v(" "), _c('h5', {
    staticClass: "title-url-address"
  }, [_c('span', [_vm._v("当前位置:")]), _vm._v(" "), _c('a', {
    staticClass: "narmal-select"
  }, [_vm._v(_vm._s(_vm.$t("header.home")) + ">")]), _vm._v(" "), _c('a', {
    staticClass: "narmal-select"
  }, [_vm._v(_vm._s(_vm.$t("header.about")) + ">")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t(("contact." + _vm.jionTab)))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contents-box"
  }, [_c('router-view')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-2 col-sm-2 col-xs-8"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(243),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contents-box row"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.$t("service.tab2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t(("service." + _vm.txt1))))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-5 prodect-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contents-box row"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.$t("service.tab3")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t(("service." + _vm.txt1))))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-5 prodect-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top navbar-app"
  }, [_c('div', {
    staticClass: "nav-default"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse navbar-right"
  }, [_c('ul', {
    staticClass: "nav navbar-nav fontColor"
  }, [_vm._l((_vm.modules), function(module, index) {
    return _c('li', {
      key: index,
      class: {
        activeUnderline: _vm.activeTo == module.to
      },
      on: {
        "click": function($event) {
          return _vm.selected(module.to)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": module.to
      }
    }, [_vm._v(_vm._s(_vm.$t(("header." + (module.name)))))])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "portals-title-page"
  }, [_c('a', {
    attrs: {
      "href": "javascript:0;"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.others")))]), _vm._v(" "), _c('div', {
    staticClass: "portal-subset-hide"
  }), _vm._v(" "), _c('ul', {
    staticClass: "portal-subset-page"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://portal.tintinhealth.com/ysmh"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.other_option1")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://ttapi.tintinhealth.com:9000/ddmanager"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.other_option2")))])])])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "###"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117),
      "alt": "Steer logo"
    }
  })])])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contents-box row"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.$t("service.tab4")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t(("service." + _vm.txt1))))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-5 prodect-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])])
},staticRenderFns: []}

/***/ })
]),[143]);


// WEBPACK FOOTER //
// static/js/app.fdf3baf34c9b56a9b72f.js